/**
 *@author yudeping
 *表单主要逻辑
 */

import Component from '../../../lib/component';
import MSG from '../../../lib/msgbox';
import './base-form.scss';
import {md5} from '../../../services/login/md5';
import {FormService} from "../../../services/formService/formService"
import {fieldTypeService, FIELD_TYPE_MAPPING} from "../../../services/dataGrid/field-type-service"
import '../../../../node_modules/jquery-ui/ui/widgets/tabs';
import {CreateFormServer} from "../../../services/formService/CreateFormServer";
import Mediator from "../../../lib/mediator";
import SettingPrint from '../setting-print/setting-print'
import AddItem from '../add-item/add-item';
import {PMAPI, PMENUM} from '../../../lib/postmsg';
import History from '../history/history'
import TextArea from '../textarea-control/textarea-area'
import Radio from '../radio-control/radio-control';
import Input from '../input-control/input-control';
import Readonly from '../readonly-control/readonly-control';
import Password from '../encrypt-input-control/encrypt-input-control';
import Hidden from '../hidden-control/hidden-control';
import SelectControl from "../select-control/select-control";
import YearControl from "../year-control/year-control";
import BuildInControl from "../buildIn-control/buildIn-control";
import MultiLinkageControl from "../multi-linkage-control/multi-linkage-control";
import YearMonthControl from "../year-month-control/year-month-control";
import TimeControl from "../time-control/time-control";
import DateControl from "../date-control/date-control";
import DateTimeControl from "../datetime-control/datetime-control";
import MultiSelectControl from "../multi-select-control/multi-select-control";
import EditorControl from "../editor-control/editor";
import SettingTextareaControl from "../setting-textarea-control/setting-textarea";
import AddEnrypt from '../encrypt-input-control/add-enrypt'
import AttachmentControl from "../attachment-control/attachment-control";
import Songrid from '../songrid-control/songrid-control';
import Correspondence from '../correspondence-control/correspondence-control';
import ContractControl from "../contract-control/contract-control";
// import RadioWX from '../radio-control/radio-control.wx';
import PostMessageGetUser from "../post-message/post-message-get-user"

import {TextAreaWX} from '../textarea-control/textarea-area'
import {RadioWX} from '../radio-control/radio-control';
import {InputWX} from '../input-control/input-control';
// import {ReadonlyWX} from '../readonly-control/readonly-control';
import {PasswordWX} from '../encrypt-input-control/encrypt-input-control';
// import HiddenWX from '../hidden-control/hidden-control.wx';
import {SelectControlWX} from "../select-control/select-control";
import {YearControlWX} from "../year-control/year-control";
import {BuildInControlWX} from "../buildIn-control/buildIn-control";
import {MultiLinkageControlWX} from "../multi-linkage-control/multi-linkage-control";
import {YearMonthControlWX} from "../year-month-control/year-month-control";
import {TimeControlWX} from "../time-control/time-control";
import {DateControlWX} from "../date-control/date-control";
import {DateTimeControlWX} from "../datetime-control/datetime-control";
import {MultiSelectControlWX} from "../multi-select-control/multi-select-control";
import {EditorControlWX} from "../editor-control/editor";
// import AddEnryptWX from '../encrypt-input-control/add-enrypt.wx'
import {AttachmentControlWX} from "../attachment-control/attachment-control";
import {SongridWX} from '../songrid-control/songrid-control';
import {CorrespondenceWX} from '../correspondence-control/correspondence-control';
import {CreateForm} from "../createFormVersionTable/createForm";

let config = {
	template: '',
	data: {
		//其他字段的数据
		dataOfOtherFields: '',
		//父表填充子表的id集合
		idsOfSonDataByParent: [],
		//本地存储已经触发默认值的数组
		baseIdsLocal: [],
		//本地存储默认值数据的dict，{ dfield: value }
		baseIdsLocalDict: {},
		//用于比较统计数据dict的dict
		myUseFields: {},
		//所有选择对应的选项
		optionsToItem: {},
		//流程Id
		flowId: '',
		//本地存储默认值数据的dict，{ dfield: value }
		baseIdsLocalDict: {},
		//用于比较字段插件配置的list
		myPluginFields: [],
		//是否验证必填
		validation_required: true,
		vote_value: '',
		vote_key: '',
		submitKey: [],
		postData: [],
		isSongCount: false,
		webCalc: {},
		SongridRef: false,
		//附件上传状态参数
		attachmentState: {},
	},
	binds: [{
		event: 'click',
		selector: '.save',
		//阻止表单数据提交之前多次提交
		callback: function () {
			for (let name in this.data.attachmentState) {
				if (this.data.attachmentState[name] === false) {
					MSG.alert(name + "尚未上传完毕，请等待附件上传完毕后提交表单！");
					return
				}
			}
			if (this.data.isBtnClick) {
				return;
			}
			this.data.isBtnClick = true;
			this.actions.onSubmit();
		}
	}, {
		event: 'click',
		selector: '.changeEdit',
		//阻止用户连续快速切换编辑模式
		callback: function () {
			if (this.data.isBtnClick) {
				return;
			}
			//默认没有点击转为编辑按钮
            this.data.changeBtnClick=false;
			this.data.isBtnClick = true;
			this.actions.changeToEdit();
			this.data.changeBtnClick=true;
		}
	}],
	actions: {
		md5: md5,
		//子表填充父表的数据
		setDataFromParent() {
			if (this.data.isFromForm != undefined && this.data.isFromForm == 0) {
				return;
			}
			if (this.data.parentTableId !== "" && window.top.frontendRelation[this.data.parentTableId] && window.top.frontendRelation[this.data.parentTableId][this.data.tableId]) {
				//父子表对应的kv关系
				let kvDict = window.top.frontendRelation[this.data.parentTableId][this.data.tableId]["pdfield_2_cdfield"];
				//父表的this.form.value
				let formDataFromParent = window.top.frontendParentFormValue[this.data.parentTableId];
				//组装子表所需列表或表单中内置或相关的父表中数据
				let parentData = FormService.packageParentDataForChildData(kvDict, formDataFromParent, this.data.parentTableId);
				//子表的this.newData
				let newDataFromSongrid = window.top.frontendParentNewData[this.data.tableId];
				this.actions.setValueForChild(kvDict, parentData, newDataFromSongrid);
				this.actions.idsInChildTableToParent();
			}
		},

		//循环给子表赋值
		setValueForChild(kvDict, parentData, newDataFromSongrid) {
			for (let key in kvDict) {
				let val = parentData[key];
				for(let songridDfield of kvDict[key]){
					//子表的dfield
					// let songridDfield = kvDict[key];
					//判断子表类型
					if (newDataFromSongrid.hasOwnProperty(songridDfield)) {
						this.data.idsOfSonDataByParent.push(songridDfield);
						let dinput_type = newDataFromSongrid[songridDfield]["dinput_type"] || "";
						if (FIELD_TYPE_MAPPING.SELECT_TYPE.indexOf(dinput_type) != -1) {
							let options = [$.type(val) == 'object' ? {value: val.value, label: val.label} : {
								value: val,
								label: val
							}];
							this.data.data[songridDfield]["options"] = options;
							this.data.data[songridDfield].isFromParent=true;
							if (this.data.childComponent && this.data.childComponent[songridDfield]) {
								this.data.childComponent[songridDfield].data["options"] = options;
							}
							this.actions.setFormValue(songridDfield, $.type(val) == 'object' ? val.value : val);
						} else {
							if (val || val == '') {
								this.actions.setFormValue(songridDfield, $.type(val) == 'object' ? val.label : val);
							}
						}
						// this.actions.triggerSingleControl(songridDfield);
					}
                }
			}
		},

		idsInChildTableToParent() {
			if (window.top.idsInChildTableToParent.hasOwnProperty(this.data.tableId)) {
				window.top.idsInChildTableToParent[this.data.tableId].concat(this.data.idsOfSonDataByParent);
			} else {
				window.top.idsInChildTableToParent[this.data.tableId] = JSON.parse(JSON.stringify(this.data.idsOfSonDataByParent));
			}
		},

		//主动触发指定字段的所有事件
		triggerSingleControl(key, noCount, defaultValue) {
			let val = this.data.data[key]["value"];
			if (val.toString() != "" || !$.isEmptyObject(val)) {
				if ($.isArray(val)) {
					if (val.length != 0) {
						this.actions.checkValue(this.data.data[key], noCount, defaultValue);
					}
				} else {
					this.actions.checkValue(this.data.data[key], noCount, defaultValue);
				}
			}
		},

		//给子表统计赋值
		async setCountData(dfield) {
			MSG.showLoadingSelf();
			this.data.postData.push(dfield);
			this.data.isSongCount = true;
			this.actions.getDataForForm();
			MSG.hideLoadingSelf();
		},

		//给外部提供formValue格式数据
		//@param isCheck判断是否需要执行表单校验
		getFormValue(isCheck) {
			// this.actions.changeValueForChildTable(this.data.data);
			return isCheck ? this.actions.createFormValue(this.data.data, true) : this.actions.createFormValue(this.data.data);
		},

		//根据dfield查找控件类型
		findTypeByDfield(dfield) {
			let type = '';
			for (let obj of this.data.formData) {
				if (obj["dfield"] == dfield) {
					type = obj["type"];
				}
			}
			return type;
		},

		//把子表内置父表的值都改成parent_temp_id
		changeValueForChildTable(data) {
			for (let key in data) {
				let type = this.actions.findTypeByDfield(key);
				let val = data[key];
				let parentTempId = data["parent_temp_id"];
				if ((this.data.idsOfSonDataByParent.length && this.data.idsOfSonDataByParent.indexOf(key) != -1 ) && val != "" && parentTempId != "" && (type == 'Buildin' || type == 'Select')) {
					data[key] = data["parent_temp_id"];
				}
			}
		},

		//创建cache数据
		//@param formData原始表单数据,val当前表单数据,isNew 是否是cacheNew
		createCacheData(formData, val, isNew) {
			let obj = {};
			for (let key in formData) {
				//自增编号old_cache置为空
				let data = formData[key];
				let newData=this.data.data[key];
				if (data.dinput_type && data.dinput_type == '14' && !isNew) {
					obj[data.dfield] = "";
				}
				for (let key in val) {
					if (key == data.dfield) {
						if (FormService.dataSelectFrom[data.type]) {
							let select = FormService.dataSelectFrom[data.type];
							if (data.type == "MultiSelect") {
								this.actions.changeMultiSelectCacheValue(isNew, data, val, obj, key,newData)
							} else if (data.type == "MultiLinkage") {
								this.actions.changeMultiLinkageCacheValue(isNew, data, val, obj, key,newData);
							} else if (data.type == "SettingTextarea") {//周期规则
								this.actions.changeSettingTextareaCacheValue(isNew, data, val, obj, key);
							} else {
								this.actions.changeSelectCacheValue(isNew, data, val, obj, key, select,newData);
							}
						} else {
							this.actions.checkNumberData(isNew, data, val, obj, key);
						}
					}
				}
			}
			return obj;
		},
		changeSelectCacheValue(isNew, data, val, obj, key, select,newData) {
			if(isNew){
                for (let option of newData[select]) {
                        if (option.value == val[key]) {
                            obj[key] = option.label;
                        }
                }
			}else{
				for(let option of data[select]){
                    if (option.value == data.value) {
                        obj[key] = option.label;
                    }
				}
			}
		},
		changeSettingTextareaCacheValue(isNew, data, val, obj, key) {
			obj[key] = '';
			if (isNew) {
				obj[key] = val[key][-1];
			} else {
				obj[key] = data.value[-1] || ''
			}
		},
		changeMultiLinkageCacheValue(isNew, data, val, obj, key,newData) {
			obj[key] = [];
			if (isNew) {
                let list = newData['dataList'];
				obj[key] = JSON.stringify(list[val[key]]);
			} else {
                let list = data['dataList'];
				obj[key] = JSON.stringify(list[data.value]);
			}
		},
		changeMultiSelectCacheValue(isNew, data, val, obj, key,newData) {
			obj[key] = [];
            if (isNew) {
                for (let option of newData['options']) {
                	let index=val[key].indexOf(option.value);
                    if (index != -1) {
                        obj[key][index]=option.label;
                    }
                }
			}else{
                for (let option of data['options']) {
                    let index=data.value.indexOf(option.value);
                    if (index != -1) {
                        obj[key][index]=option.label;
                    }
                }
			}
			obj[key] = JSON.stringify(obj[key]);
		},

		checkNumberData(isNew, data, val, obj, key) {
			if (isNew) {
				if (data['real_type'] && ( data['real_type'] == '10' || data['real_type'] == '11' )) {
					obj[key] = Number(val[key]);
				} else {
					obj[key] = val[key];
				}
			} else {
				if (data['real_type'] && ( data['real_type'] == '10' || data['real_type'] == '11' )) {
					obj[key] = Number(data.value);
				} else {
					obj[key] = data.value;
				}
			}
		},

		//提交检查
		//@param allData全部控件属性,formvalue 表单值格式
		validForm(allData, formValue) {
			let error = false;
			let errorMsg = "";
			let errArr = [];
			for (let key in formValue) {
				let data = allData[key];
				//列权限处理
				if (Object.is(allData[key]['unvisible'], 1)) {
					continue;
				}
				//如果该dfield是父表填充子表的，那就不验证
				if (this.data.idsOfSonDataByParent.indexOf(key) != -1) {
					continue;
				}
				if (data.be_control_condition) {
					//如果被修改条件限制，将值置为空在保存
					formValue[key] = '';
					continue;
				}
				let type = data["type"];
				if (type == 'Songrid') {
					continue;
				}
				let val = formValue[key];
				//必填检查
				if (data["required"] && data['required_perm'] && this.data.validation_required) {
					if (( ( val == "" ) && ( ( val + '' ) != '0' ) ) || val == "[]" || JSON.stringify(val) == "{}") {
						error = true;
						errArr.push(data["label"] + '是必填项!');
						errorMsg = errArr.join(' ');
						continue;
					}
					if(data.selectLabel != undefined){
						if(data.selectLabel ==''){
                            error = true;
                            errArr.push(data["label"] + '是必填项!');
                            errorMsg = errArr.join(' ');
                            continue;
						}
					}
				}
				//子表必填 对应关系必填
				for (let d in allData) {
					if (allData[d].type == 'Songrid' && allData[d].required && allData[d].required_perm && allData[d].total == 0) {
						error = true;
						errArr.push('子表字段:' + allData[d].label + '是必填!');
						errorMsg = Array.from(new Set(errArr)).join(' ');
						break;
					}
					if (allData[d].type == 'Correspondence' && allData[d].required && allData[d].required_perm && !allData[d].correspondenceHasValue) {
						error = true;
						errArr.push('对应关系:' + allData[d].label + '是必填!');
						errorMsg = Array.from(new Set(errArr)).join(' ');
						break;
					}
				}
				//正则检查
				if (val != "" && data["reg"] !== "") {
					for (let r in data["reg"]) {
						let reg;
						//有待优化
						if (r.startsWith('/') && r.endsWith('/')) {
							// r = r.substring(1)
							// r = r.substring(0, r.length - 1);
							reg = eval(r);
						} else {
							reg = new RegExp(r);
						}
						let flag = reg.test(val);
						if (!flag) {
							error = true;
							errorMsg = data["reg"][r];
							break;
						}
					}
				}
				//数字范围检查
				if (val.toString() != "" && data["numArea"]) {
					let label = data["label"];
					let minNum = data["numArea"]["min"] || '';
					let maxNum = data["numArea"]["max"] || '';
					if (data["numArea"]["min"].toString() == '0') {
						minNum = '0';
					}
					if (data["numArea"]["max"].toString() == '0') {
						maxNum = '0';
					}
					let errorInfo = data["numArea"]["error"];
					if (minNum !== "" && maxNum === "") {
						if (val < minNum) {
							error = true;
							if (errorInfo === "") {
								errorMsg = `“${ label }”字段不能小于${ minNum }`;
							} else {
								errorMsg = errorInfo;
							}
							break;
						}
					} else if (minNum === "" && maxNum !== "") {
						if (val > maxNum) {
							error = true;
							if (errorInfo === "") {
								errorMsg = `“${ label }”字段不能大于${ minNum }`;
							} else {
								errorMsg = errorInfo;
							}
							break;
						}
					} else {
						if (val < minNum || val > maxNum) {
							error = true;
							if (errorInfo === "") {
								errorMsg = `“${ label }”字段的取值范围在${ minNum } 和 ${ maxNum }内`;
							} else {
								errorMsg = errorInfo;
							}
							break;
						}
					}
				}
				//函数检查
				if (val != "" && !$.isEmptyObject(data["func"])) {
					for (let r in data["func"]) {
						let flag = FormService[r](val);
						if (!flag) {
							error = true;
							errorMsg = data["func"][r];
							break;
						}
					}
				}
				//数字位数限制
				if (data["real_type"] == fieldTypeService.FLOAT_TYPE) {
					if (formValue[key] >= 100000000000) {
						error = true;
						errorMsg = "小数不能超过12位！无法保存！";
						break;
					}
				}
			}
			return {
				error,
				errorMsg
			};
		},

		//审批数据是删除情况不可编辑
		//暂时无用
		editDelWork(res) {
			if (res && res == this.formId) {
				for (let key in this.data.data) {
					this.data.data[key]['is_view'] = 1;
					this.data.childComponent[key].data['is_view'] = 1;
					this.data.childComponent[key].reload();
				}
			}
		},

		//检查是否是默认值的触发条件
		async validDefault(originalData, val) {
			if (this.data.baseIdsLocal.indexOf(originalData["dfield"]) == -1) {
				this.data.baseIdsLocal.push(originalData["dfield"]);
			}
			this.data.baseIdsLocalDict[originalData["dfield"]] = val;
			if(this.data.reloadDraftData){
				return;
			}
			//编辑模式
			if (window.config.btnType === 'edit') {
                return;
			}
			if (this.data.base_fields.sort().toString() == this.data.baseIdsLocal.sort().toString()) {
				//请求默认值
				let json = {
					flow_id: this.data.flowId || "",
					base_field_2_value: JSON.stringify(this.data.baseIdsLocalDict),
					temp_id: this.data.data.temp_id["value"]
				};
				MSG.showLoadingSelf();
				let res = await FormService.getDefaultValue(json);
				this.actions.setValueForDefault(res)
				MSG.hideLoadingSelf();
			}
		},

		//设置默认值
		setValueForDefault(res) {
			for (let key in res["data"]) {
				//排除例外字段
				if (this.data.exclude_fields.indexOf(key) == -1) {
					if (this.data.data.hasOwnProperty(key)) {
						let data = this.data.data[key];
						let tableId = this.data.tableId;
						let type = data["type"];
						let value = res["data"][key];
						//如果是对应关系,传回来的是空串，那就不对它赋值
						if (type == 'correspondence' && value == "") {
							continue;
						}

						this.actions.setFormValue(key, value, false, false);
					}
				}
			}
		},

		checkDefaultFieldType(key, type, value, data) {
			//如果是对应关系回显默认值
			if (type == 'correspondence' && value != "") {
				this.actions.setCorrespondenceDefaultValue(key, data);
			}
			//如果是内联子表默认值
			if (type == 'songrid') {
				this.actions.setSongridDefaultValue(key, data);
			}
			//如果是多级内置
			if (type == 'multi-linkage') {
				this.actions.setMultiLinkageDefaultValue(key, value);
			}
			//如果是日期控件
			if (type == 'datetime') {
				this.actions.setDatetimeDefaultValue(key, value);
			}
			//如果是周期规则
			if (type == 'setting-textarea') {
				this.actions.setSettingTextareaDefaultValue(key, value);
			}
		},

		setCorrespondenceDefaultValue(key, data) {
			this.data.childComponent[key].actions.correspondenceDefault(data['value']);
		},
		setSongridDefaultValue(key, data) {
			this.data.childComponent[key].actions.songridDefault(data['value']);
		},
		setMultiLinkageDefaultValue(key, value) {
			if (value.length != 0) {
				this.data.childComponent[key].actions.multiLinkageDefaultData(value);
			} else {
				this.data.childComponent[key].actions.multiLinkageDefaultData('none');
			}
		},
		setDatetimeDefaultValue(key, value) {
			value = value.replace(" ", "T");
			this.setFormValue(key, value);
		},
		setSettingTextareaDefaultValue(key, value) {
			this.data.childComponent[key].actions.loadSettingtextarea(value);
		},

		//主动触发一遍所有事件
		//二次确认挂有关系的数据的准确性
		triggerControl: function () {
			let data = this.data.data;
			for (let key in data) {
				let val = data[key]["value"];
				if (val != "" || !$.isEmptyObject(val)) {
					if ($.isArray(val)) {
						if (val.length != 0) {
							this.actions.checkValue(data[key]);
						}
					} else {
						this.actions.checkValue(data[key]);
					}
				}
			}
		},

		//通过枚举选项的id，寻找对应的text
		getTextByOptionID(dfield, value) {
			let text = '';
			let options;
			let data = this.data.data;
			if (data[dfield].hasOwnProperty("options")) {
				options = data[dfield]["options"];
			}
			else if (data[dfield].hasOwnProperty("group")) {
				options = data[dfield]["group"];
			}
			for (let key in options) {
				if (options[key]["value"] == value) {
					text = options[key]["label"];
				}
			}
			return `${ text}`;
		},

		//为控件赋值前检验
		set_value_for_form(result, f) {
			let data = this.data.data[f];
			if (typeof result === 'string') {
				//条件表达式赋值
				this.actions.setFormValue(f, result);
			} else if (isNaN(result) || !isFinite(result)) {
				//容错
				this.actions.setFormValue(f, "");
			} else {
				//如果是整数
				if (data["real_type"] == 11) {
					this.actions.setFormValue(f, result);
				} else {
					if (FIELD_TYPE_MAPPING.NUMBER_TYPE.indexOf(data["real_type"]) != -1) {
						let reg = /^((-?\d+.?\d*)[Ee]{1}([+-]?\d+))$/;
						if (reg.test(data.value)) {
							data.value = data.value + "(不支持科学计数法！无法保存！)"
							this.actions.setFormValue(f, data.value);
							return;
						}
					}
					//如果是浮点数
					//数据处理（如果数据已经限定了小数位数，如果不满足，四舍五入让其满足）
					let accuracy = data["accuracy"];
					result = result.toFixed(accuracy);
					this.actions.setFormValue(f, result);

					//数据溢出出现科学计数法时
					if (FIELD_TYPE_MAPPING.NUMBER_TYPE.indexOf(data["real_type"]) != -1) {
						let reg = /^((-?\d+.?\d*)[Ee]{1}([+-]?\d+))$/;
						if (reg.test(data.value)) {
							data.value = data.value + "(不支持科学计数法！无法保存！)"
							this.actions.setFormValue(f, data.value);
							return;
						}
						//浮点数数据溢出时（后台浮点数最大位数为11位，超过11位便会返回科学计数法）
						else if (data["real_type"] == fieldTypeService.FLOAT_TYPE) {
							if (result >= 100000000000) {
								if (data.value.indexOf("(") == -1) {
									data.value = data.value + "(小数不能超过12位！无法保存！)"
									this.actions.setFormValue(f, data.value);
								}
								return;
							}
						}
					}
				}
			}
			//统计功能
			// this.actions.countFunc(f);
			//字段插件配置
			this.actions.pluginForFields(f);
		},

		//字段插件配置
		pluginForFields(dfield) {
			if (this.data.myPluginFields.indexOf(dfield) == -1) {
				this.data.myPluginFields.push(dfield);
			}
			for (let hasThisFieldList of this.data.plugin_fields) {
				if (hasThisFieldList.indexOf(dfield) != -1) {
					let isAllInclude = true;
					this.actions.pluginAllInclude(isAllInclude, hasThisFieldList);
					//触发
					if (isAllInclude) {
						this.actions.allIncludeIsTrue(hasThisFieldList);
					}
				}
			}
		},
		pluginAllInclude(isAllInclude, hasThisFieldList) {
			for (let item of hasThisFieldList) {
				if (this.data.myPluginFields.indexOf(item) == -1) {
					isAllInclude = false;
				}
			}
		},
		allIncludeIsTrue(hasThisFieldList) {
			let dfield2value = {};
			let formValue = this.actions.getFormValue();
			for (let i of hasThisFieldList) {
				dfield2value[i] = formValue[i];
			}
			FormService.execFieldPlugin({
				form_id: this.data.formId,
				temp_id: this.data.temp_id["value"],
				real_id: this.data.real_id["value"],
				dfield2value: JSON.stringify(dfield2value)
			});
		},
		/**
		 * 从编辑转到查看模式
		 */
		async changeToView() {
			for (let key in this.data.data) {
				if (this.data.childComponent[key]) {
					this.data.childComponent[key].data.is_view = this.data.data[key].is_view = 1;
					this.data.childComponent[key].reload();
				}
			}
			this.actions.triggerControl();
		},

		/**
		 *  表达式主要方法
		 *  此data结构为{val: 自身的value,effect: [] 被影响的dfield集合}
		 *  暂时只有后端表达式计算，以后需要加上前端表达式判断
		 */
		async calcExpression(data) {
			// let send_exps = [];
			if (!data["effect"] || !data["effect"].length > 0) {
				return false;
			} else {
				return true;
			}
		},

		//改变选择框的选项
		changeOptions() {
			if(this.data.isAddLinkage ) {
                this.data.isAddLinkage =false;
                this.actions.saveChangeOptionsToItem();
			}else  {
                this.actions.saveChangeOptions();
			}
			for (let key in this.data.data) {
				let data = this.data.data[key];
				let obj = {'Select': 'options', 'Radio': 'group', 'MultiSelect': 'options', 'Readonly': 'options'};
				if (!_.isEmpty(data['linkage'])) {
					let j = 0;
					let arr = [];
					j = this.actions.checkHasChangeOptions(data, arr, j);
					if (j == 0) {
						this.actions.notHaveChangeOptions(arr, obj);
					}
				}
			}
		},

		notHaveChangeOptions(arr, obj) {
			for (let field of arr) {
				this.data.data[field][obj[this.data.data[field]['type']]] = this.data.optionsToItem;
				if (this.data.childComponent[field].data) {
					this.data.childComponent[field].data[obj[this.data.data[field]['type']]] = this.data.optionsToItem[field];
					this.data.childComponent[field].reload();
				}
			}
		},

		checkHasChangeOptions(data, arr, j) {
			for (let value in data['linkage']) {
				for (let k in data['linkage'][value]) {
					arr.push(k);
				}
				if (value == data['value']) {
					j++;
					//改变选择框的选项
					this.actions.changeOptionOfSelect(data, data['linkage'][value]);
				}
			}
			return j;
		},

		saveChangeOptions() {
			for (let key in this.data.data) {
				let data = this.data.data[key];
				let obj = FormService.selectObj;
				let affectType = data['type'];
				if (!obj[affectType]) {
					continue;
				}
				let affectOptions = data[obj[affectType]];
				if (!this.data.optionsToItem[key]) {
					this.data.optionsToItem[key] = [];
					for (let index in affectOptions) {
						this.data.optionsToItem[key].push(affectOptions[index]);
					}
				}
			}
		},
		//快捷添加下拉框数据初始化
        saveChangeOptionsToItem() {
            this.data.optionsToItem = {};
            for (let key in this.data.data) {
                let data = this.data.data[key];
                let affectOptions = data['originalOptions'];
                if (!this.data.optionsToItem[key]) {
                    this.data.optionsToItem[key] = [];
                    for (let index in affectOptions) {
                        this.data.optionsToItem[key].push(affectOptions[index]);
                    }
                }
            }
        },
		//改变选择框的选项
		changeOptionOfSelect(data, l) {
			let obj = {'Select': 'options', 'Radio': 'group', 'MultiSelect': 'options'};
			let linkage = l;
			// let field = data['dfield'];
			let type = data['type'];
			for (let key in linkage) {
				let affectData = this.data.data[key];
				let affectType = affectData['type'];
				let arr = [];
				let srcOptions = this.data.optionsToItem[key];
				for (let opIndex in srcOptions) {
					if (linkage[key].indexOf(srcOptions[opIndex].value) != -1) {
						arr.push(srcOptions[opIndex]);
					}
				}
				this.data.data[key][obj[affectType]] = arr;
				if (this.data.childComponent[key]) {
					this.data.childComponent[key].data[obj[affectType]] = arr;
					this.data.childComponent[key].reload();
				}
				// if (affectType == 'multi-select') {
				// 	this.data.data[key]['value'] = [];
				// } else {
				// 	this.data.data[key]['value'] = '';
				// }
				// this.data.childComponent[this.data.data[key]['dfield']].actions.changeOption(this.data.data[key]['dfield']);
			}
		},

		//修改必填性功能
		requiredCondition(editConditionDict, value) {
			let arr = [];
			for (let key in editConditionDict["required_condition"]) {
				if (key == 'and') {
					this.actions.andRequiredCondition(editConditionDict, key, value);
				} else if (key == 'term') {
                    this.actions.termRequiredCondition(editConditionDict, key, value);
				} else {
					this.actions.otherRequiredCondition(editConditionDict, key, value, arr);
				}
			}
		},

		otherRequiredCondition(editConditionDict, key, value, arr) {
            for (let dfield of editConditionDict["required_condition"][key]) {
                if (arr.indexOf(dfield) != -1) {
                    continue;
                }
                this.data.data[dfield]["required"] = this.data.childComponent[dfield].data['required'] = (key == value) ? 1 : 0;
                if (this.data.childComponent[dfield].data['required']) {
                    this.data.childComponent[dfield].data['requiredClass'] = this.data.childComponent[dfield].data.value == '' ? 'required' + this.data.fontsize : 'required2' + this.data.fontsize;
                }
                this.data.childComponent[dfield].reload();
                if (key == value) {
                    arr.push(dfield);
                }
            }
		},

		andRequiredCondition(editConditionDict, key, value) {
            let andData = editConditionDict["required_condition"][key];
            for (let f in andData) {
                let i = 0;
                for (let d of andData[f]) {
                    if (value instanceof Array) {
                        for (let b of value) {//与的情况  多个条件
                            if (d == b) {
                                i++;
                            }
                        }
                    } else {
                        if (d == value) {//与的情况  单个条件
                            i++;
                        }
                    }
                }
                //为查看模式    只能查看不能编辑
                if (this.data.btnType === 'view') {
                    this.data.data[f]["is_view"] = 1;
                } else {
                    this.data.data[f]["required"] = this.data.childComponent[f].data['required'] = (i == andData[f].length) ? 1 : 0;
                    if (this.data.childComponent[f].data['required']) {
                        this.data.childComponent[f].data['requiredClass'] = this.data.childComponent[f].data.value == '' ? 'required' + this.data.fontsize : 'required2' + this.data.fontsize;
                    }
                }
				this.data.childComponent[f].reload();
			}
		},
        termRequiredCondition (editConditionDict, key, value) {
            for (let dfield in editConditionDict["required_condition"][key].data) {
				let data1 = this.data.data[dfield];
                let eqname = [];//文本类型   满足得条件字段
                let neqName = [];//文本类型    不满得条件字段
				data1.required = 0;
				//如果是数字类型得    and情况
                if (editConditionDict.real_type == '26' || editConditionDict.real_type == '10' || editConditionDict.real_type == '11') {

                } else {
                    //不是数组类型的  and情况
                    for (let k = 0; k < editConditionDict["required_condition"][key].data[dfield].length; k++) {
                    	//输入的字段等于的时候
                        if (editConditionDict["required_condition"][key].data[dfield][k].k == 'eq') {
                            eqname.push(editConditionDict["required_condition"][key].data[dfield][k].v);
                        } else if (editConditionDict["required_condition"][key].data[dfield][k].k == 'neq') {//不等于
                            neqName.push(editConditionDict["required_condition"][key].data[dfield][k].v);
                        }
                    }
				}
				for (let data of editConditionDict["required_condition"][key].data[dfield]) {
                	//判断条件为或   或者  为空  都走或者的关系
					if (editConditionDict["required_condition"][key].relation_mapping[dfield] != 'and') {
                        if (data.k == 'eq') {
                            if (editConditionDict.type == 'Buildin') {//内置字段用selectLabel判断值是否相等
                                if (editConditionDict.selectLabel == data.v) {
                                    data1.required = 1;
                                }
                            }else if (editConditionDict.type == 'MultiSelect') {//多选内置字段用multiSelectLabel判断数组中是否包含 eqname这个中的元素
                                this.actions.multiSelectData(editConditionDict);
                                if (editConditionDict.multiSelectLabel) {
                                    for (let h = 0; h < editConditionDict.multiSelectLabel.length; h++) {
                                        if (eqname.indexOf(editConditionDict.multiSelectLabel[h]) != -1) {
                                            data1.required = 1;
                                        }
                                    }
                                }
                            } else if (value == data.v) {
                                data1.required = 1;
                            }
                        } else if (data.k == 'neq') {
                            if (editConditionDict.type == 'Buildin') {    //内置字段用selectLabel判断值是否相等
                                if (editConditionDict.selectLabel != data.v) {
                                    data1.required = 1;
                                }
                            } else if (editConditionDict.type == 'MultiSelect') {//多选内置字段用multiSelectLabel判断数组中是否包含 neqName
                                this.actions.multiSelectData(editConditionDict);
                                if (editConditionDict.multiSelectLabel) {
                                    for (let h=0;h<editConditionDict.multiSelectLabel.length;h++) {
                                        if (neqName.indexOf(editConditionDict.multiSelectLabel[h]) == -1) {
                                            data1.required = 1;
                                        }
                                    }
                                }
                            } else if (value != data.v) {
                                data1.required = 1;
                            }
                        }
                        if (editConditionDict.real_type == '26' || editConditionDict.real_type == '10' || editConditionDict.real_type == '11') {
                            let val = Number(value);
                            if (val || val == 0) {//   为零也的验证
                                if (data.k == 'gt') {
                                    if (val > data.v) {
                                        data1.required = 1;
                                    }
                                } else if (data.k == 'gte') {
                                    if (val >= data.v) {
                                        data1.required = 1;
                                    }
                                } else if (data.k == 'lt') {
                                    if (val < data.v) {
                                        data1.required = 1;
                                    }
                                } else if (data.k == 'lte') {
                                    if (val <= data.v) {
                                        data1.required = 1;
                                    }
                                }
                            }
                        }
					} else {
						//判断条件为与的时候
                        if (data.k == 'eq') {
                            if (editConditionDict.type == 'Buildin') {//内置字段用selectLabel判断值是否相等
                                //单选内置条件不满足就直接跳出循环  等于（eqname）的条件只能有一个  否则不通过
                                if (neqName.indexOf(editConditionDict.selectLabel) == -1 && eqname.indexOf(editConditionDict.selectLabel) == 0 && eqname.length == 1) {
                                    data1.required = 1;
                                } else {
                                    data1.required = 0;
                                    break;
                                }
                            } else if (editConditionDict.type == 'MultiSelect') {//多选内置字段用multiSelectLabel判断数组是否都包含了 eqname 数组中的值
                                this.actions.multiSelectData(editConditionDict);
                                if (editConditionDict.multiSelectLabel) {
									let eqVauleName = [];
									for (let i=0;i<editConditionDict.multiSelectLabel.length;i++) {
										if (eqname.indexOf(editConditionDict.multiSelectLabel[i]) != -1) {
											eqVauleName.push(editConditionDict.multiSelectLabel[i]);
										}
									}
									if (eqVauleName.length === eqname.length) {
										data1.required = 1;
									} else {
										data1.required = 0;
										break;
									}
                                } else {
                                    data1.required = 0;
                                    break;
								}
                            } else if (eqname.indexOf(value)!= -1) {
                                data1.required = 1;
                            } else {
                                data1.required = 0;
                                break;
                            }
                        } else if (data.k == 'neq') {
                            if (editConditionDict.type == 'Buildin') {//内置字段用selectLabel判断值是否相等
                                //单选内置条件不满足就直接跳出循环  等于（eqname）的条件只能有一个  否则不通过
                                if (neqName.indexOf(editConditionDict.selectLabel) == -1 && eqname.indexOf(editConditionDict.selectLabel) == 0 && eqname.length == 1) {
                                    data1.required = 1;
                                }else if (neqName.indexOf(editConditionDict.selectLabel) == -1 && eqname.length == 0){
                                    data1.required = 1;
                                }  else {
                                    data1.required = 0;
                                    break;
                                }
                            }  else if (editConditionDict.type == 'MultiSelect') {//多选内置字段用multiSelectLabel判断数组是否包含了不等于的值   neqName
                                this.actions.multiSelectData(editConditionDict);
                                if (editConditionDict.multiSelectLabel) {
                                    let neqVauleName = [];
                                    for (let k=0;k<neqName.length;k++) {
                                        if(editConditionDict.multiSelectLabel.indexOf(neqName[k]) != -1) {
                                            neqVauleName.push(neqName[k]);
                                        }
                                    }
                                    if (neqVauleName.length === 0 ) {
                                        data1.required = 1;
                                    } else {
                                        data1.required = 0;
                                        break;
                                    }
                                } else {
                                    data1.required = 0;
                                    break;
                                }
                            } else if (neqName.indexOf(value) == -1) {
                                data1.required = 1;
                            } else {
                                data1.required = 0;
                                break;
                            }
                        }
                        if (editConditionDict.real_type == '26' || editConditionDict.real_type == '10' || editConditionDict.real_type == '11') {
                            let val = Number(value);
                            //为数字类型的的时候   要同时满足条件
                            if (val || val == 0) {
                                if (data.k == 'gt') {
                                    if (val > data.v) {
                                        data1.required = 1;
                                    } else {
                                        data1.required = 0;
                                        break;
									}
                                } else if (data.k == 'gte') {
                                    if (val >= data.v) {
                                        data1.required = 1;
                                    } else {
                                        data1.required = 0;
                                        break;
                                    }
                                } else if (data.k == 'lt') {
                                    if (val < data.v) {
                                        data1.required = 1;
                                    } else {
                                        data1.required = 0;
                                        break;
                                    }
                                } else if (data.k == 'lte') {
                                    if (val <= data.v) {
                                        data1.required = 1;
                                    } else {
                                        data1.required = 0;
                                        break;
                                    }
                                }
                            }
                        }
					}
				}
				this.data.data[dfield]["required"] = this.data.childComponent[dfield].data['required'] = data1.required;
				if (this.data.childComponent[dfield].data['required']) {
					this.data.childComponent[dfield].data['requiredClass'] = this.data.childComponent[dfield].data.value == '' ? 'required' + this.data.fontsize : 'required2' + this.data.fontsize;
				}
				this.data.childComponent[dfield].reload();
            }
        },

		//创建表单数据格式 形如{dfield:value}
		//@param data为当前表单最新的数据，isCheck 是否执行表单校验
		createFormValue(data, isCheck) {
			let formValue = {};
			this.actions.replaceStringValue(data, formValue);
			if (isCheck) {
				//外部调用需要验证表单
				let {error, errorMsg} = this.actions.validForm(this.data.data, formValue);
				if (error) {
					return {
						error: error,
						errorMessage: errorMsg
					}
				} else {
					// this.actions.checkOhterField(formValue);
					return formValue;
				}
			} else {
				return formValue;
			}

		},

        replaceStringValue(data, formValue) {
            for (let key in data) {
                if (data[key].value && data[key].dtype == 1 && typeof data[key].value == 'string') {
                    formValue[key] = Number(data[key].value.replace(/,/g, ''));
                }
                else if (data[key].value && data[key].real_type == 11){//解决如果是整数,向下取整  年份控件中有千分号   的去除
                    if (typeof data[key].value == 'string' && data[key].value.indexOf(',') != -1) {
                        formValue[key] = Math.floor(data[key].value.replace(/,/g, ''));
                    } else {
                        formValue[key] = Math.floor(data[key].value);
                    }
				} else {
                    formValue[key] = data[key].value;
                }
                if (Object.is(data[key]['unvisible'], 1)) {
                    delete formValue[key];
                }
            }
        },
		//判断一下日期的类型，并且进行限制
		//当数据不符格式限制时，要将对应表单值设为空
		checkDateType(data) {
			for (let i in this.data.data) {
				let temp = this.data.data[i];
				let dfield = this.data.data[i]['dfield'];//f8
				if (this.data.data[i]['type'] == 'Date') {

					if (temp['timeType'] == 'after') {
						this.actions.afterDate(data, dfield);
					} else if (this.data.data[i]['type'] == 'before') {
						this.actions.beforeDate(data, dfield);
					}
				}
				if (this.data.data[i]['type'] == 'Datetime') {
					if (temp['timeType'] == 'after') {
						this.actions.afterDateTime(data, dfield);
					} else if (this.data.data[i]['type'] == 'before') {
						this.actions.beforeDateTime(data, dfield);
					}
				}
			}
		},

		afterDateTime(data, dfield) {
			let vals = data[dfield].split(" ")[0].split("-");
			//let vals = val.split("-");//[2011,11,11];
			let myData = new Date();
			let dates = [myData.getFullYear(), myData.getMonth() + 1, myData.getDate()];
			for (let i = 0; i < 3; i++) {
				if (vals[i] < dates[i]) {
					data[dfield] = '';
				}
			}
		},

		beforeDateTime(data, dfield) {
			let vals = data[dfield].split(" ")[0].split("-");
			//let vals = val.split("-");//[2011,11,11];
			let myData = new Date();
			let dates = [myData.getFullYear(), myData.getMonth() + 1, myData.getDate()];
			for (let i = 0; i < 3; i++) {
				if (vals[i] < dates[i]) {
					data[dfield] = '';
				}
			}
		},

		beforeDate(data, dfield) {
            let myData = new Date();
            let date=new Date(myData.getFullYear()+'-'+(myData.getMonth()+1)+'-'+myData.getDate());
            if(new Date(data[dfield]) > date){
                data[dfield]='';
            }
		},

		afterDate(data, dfield) {
            let myData = new Date();
            let date=new Date(myData.getFullYear()+'-'+(myData.getMonth()+1)+'-'+myData.getDate());
			if(new Date(data[dfield]) < date){
				data[dfield]='';
			}
		},

		//多字段统计提前修改myUseFields
		myUseFieldsofcountFunc() {
			this.data.myUseFields = JSON.parse(JSON.stringify(this.data['use_fields']))
		},

		//统计功能
		async countFunc(dfield) {
			let isPush = false;
			for (let key in this.data['use_fields']) {
				let data = this.data.myUseFields[key];
				if (this.data['use_fields'][key].indexOf(dfield) != -1) {
					if (!data) {
						data = [];
					}
					if (data.indexOf(dfield) == -1) {
						data.push(dfield);
					}
					if (this.data['use_fields'][key].sort().toString() == data.sort().toString()) {
						isPush = true;
					}
				}
			}
			return isPush;
		},

		//处理表单数据，根据real_type转换数据
		handleFormData(formData) {
			for (let dfield in formData) {
				let data = this.data.data[dfield];
				let fData = formData[dfield];
				if (data["real_type"]) {
					if (data["real_type"] == 10 || data["real_type"] == 11) {
						try {
							let result;
							if (fData != "") {
								result = Number(fData);
							}
							if (result != null && result != undefined && !isNaN(result)) {
								fData = Number(fData);
							}
						} catch (e) {
							console.error("转换数字类型失败");
						}
					}
					if (data["real_type"] == 5 && !!fData) {
						fData = fData.replace("T", " ");
					}
				}
			}
			return formData;
		},

		//必填性改变
		requiredChange(_this) {
			if (_this.data.value === '' || _this.data.value.length === 0 || JSON.stringify(_this.data.value) === "{}") {
				_this.el.find('#requiredLogo').removeClass().addClass('required' + this.data.fontsize);
				_this.data.requiredClass='required' + this.data.fontsize;
			} else {
				_this.el.find('#requiredLogo').removeClass().addClass('required2' + this.data.fontsize);
				_this.data.requiredClass='required2' + this.data.fontsize
			}
			//富文本必填性改变
			if (_this.data.type == 'Editor' && ( _this.data.value.replace(/<.*?>/ig, "").replace(/\s/g, "") === '' )) {
				_this.el.find('#requiredLogo').removeClass().addClass('required' + this.data.fontsize);
			}
			//内置必填性二次检查
			if(_this.data.type == 'Buildin' && _this.data.selectLabel != undefined && _this.data.value){
				this.data.data[_this.data.dfield].selectLabel=_this.data.selectLabel;
                if (_this.data.selectLabel === '') {
					_this.el.find('#requiredLogo').removeClass().addClass('required' + this.data.fontsize);
				} else {
					_this.el.find('#requiredLogo').removeClass().addClass('required2' + this.data.fontsize);
				}
			}
		},
		setRadioCheck(data) {
			for (let obj of data.group) {
				obj['name'] = data.dfield;
				if (obj.value == data.value) {
					obj['checked'] = true;
				} else {
					obj['checked'] = false;
				}
			}
		},
		//赋值
		setFormValue(dfield, value, noCount, defaultValue) {
			let count = !noCount ? true : false;
			let data = this.data.data[dfield];
			if (data) {
				data["value"] = value;
				this.actions.setAccuracy(data);
				let childComponet = !this.data.isWX && this.data.childComponent[dfield];
				if (data.type == 'Radio') {
					this.actions.setRadioCheck(data);
				}
				if (!this.data.isWX && childComponet) {
					childComponet.data["value"] = data["value"]
					if (data.type == 'Radio') {
						this.actions.setRadioCheck(childComponet.data);
					}
					childComponet.reload();
				}
				if (this.data.isWX) {
					this.actions.setWXvalue(dfield, data);
				}
				this.actions.triggerSingleControl(dfield, count, defaultValue);
			}
		},

		setWXvalue(dfield, data) {
			let span = '';
			if (data.required && (data.value === '' || data.value.length === 0 || JSON.stringify(data.value) === "{}")) {
				span = '<span class="required"></span>'
			}
			let value = span + this.actions.createWXControlValue(dfield, data, data.type)
			this.el.find(`div[data-dfield=${dfield}]`).get(0).innerHTML = value;
		},
		//给相关赋值
		setAboutData(id, value) {
			let buildin_fields = {};
			buildin_fields[id] = value;
			this.data.buildin_fields = buildin_fields;
		},
		//快捷添加后回显
		addNewItem(data) {
			let dfield = this.data['quikAddDfield'];
			let fieldData = this.data.data[dfield];
			if (fieldData["options"]) {
				this.data.childComponent[dfield]['data']['options']=this.data.childComponent[dfield]['data']["originalOptions"] = fieldData["options"] = fieldData["originalOptions"] = this.data.optionsToItem[dfield]= data['newItems'];
			} else {
				this.data.childComponent[dfield]['data']['group'] =this.data.childComponent[dfield]['data']["originalOptions"] = fieldData["group"] = fieldData["originalOptions"] = this.data.optionsToItem[dfield] = data['newItems'];
			}
			//affect_field  表示 当前新增选项的字段 为哪些字段提供联动
            // base_field 表单 当前新增选项的字段 联动的数据源是哪个字段
            if(data['linkage'] && Object.keys(data['linkage']).length !== 0) {
                let linkage = data.linkage || {};
                let affect_field = linkage.affect_field || [];
                let base_field = linkage.base_field || [];
                let this_data = this.data.data;
                let new_linkage_data = [];
                let linkage_data = affect_field.length>0 ? affect_field : base_field;
                linkage_data.forEach((lk)=>{
                    //当前新增字段拼接联动字段数据
                    let obj = {};
                    let d = this_data[lk];
                    obj['label'] = d['label'];
                    obj['dfield'] = d['dfield'];
                    obj['field_content'] = this.data.data[lk]["originalOptions"].filter(item=>{
                        return item.value !== '';
                    });
                    new_linkage_data.push(obj);
                    //更新联动字段备选项
                    let childNewData = this.data.childComponent[lk].data.new_data || [];
                    childNewData.forEach(child=>{
                        child['new_linkage_data'].forEach(n_data=>{
                            if(n_data.dfield === dfield) {
                                //合并原选项和新增选项并去重
                                n_data['field_content'] = Array.from(new Set([...n_data['field_content'],...data['new_data_linkage']]));
                            }
                        })
                    })
                })
                data['new_data'].forEach(d=>{
                    d['new_linkage_data'] =new_linkage_data;
                })
                this.data.childComponent[dfield].data.new_data = data['new_data'];
                this.data.childComponent[dfield].data.is_linkage = true;
                this.data.childComponent[dfield].el.find('.add-linkage').css('visibility','visible');
                this.data.childComponent[dfield].data.fields = linkage_data || [];

                //联动的数据重置
				Array.from(new Set([...linkage_data,dfield])).forEach(item=>{
					this.data.childComponent[item]['data']['value'] = this.data.data[item]["value"] = '';
					this.actions.checkValue(this.data.data[item]);
					this.data.childComponent[item].reload();
				})
			}else {
                this.data.childComponent[dfield].reload();
			}
		},

		async firstGetData() {
			let buildin_fields = {}
			for (let index in this.data.data) {
				let data = this.data.data[index];
				if (data.type == 'Buildin') {
					this.actions.checkBuildValue(data, buildin_fields);
				} else {
					if ((data.value || (data.effect && data.effect.length && data.effect.length > 0)) && data.dfield.startsWith('f') && !(~this.data.postData.indexOf(data.dfield))) {
						if (typeof data.value == 'string' && data.value.trim() == '' && data.effect.length == 0) {
							continue;
						}
						this.data.postData.push(data.dfield);
					}
				}
			}
			this.data.buildin_fields = buildin_fields;
            if(this.data.isView==0){
                await this.actions.getDataForForm();
			}

		},

		checkBuildValue(data, buildin_fields) {
			let id = data["id"];
			let value;
			for (let obj of data['options']) {
				if (obj.value == data.value) {
					value = obj.value;
					break;
				}
			}
			if (value && value != '') {
				buildin_fields[id] = value;
			}
		},

		async getDataForForm() {
			if (this.data.postData.length == 0 && $.isEmptyObject(this.data.buildin_fields)) {
				this.actions.afterGetDataForForm();
				return;
			}
			let data = {};
			data.data = this.actions.createFormValue(this.data.data);
			data.count_data = this.actions.createFormValue(this.data.data);
			for (let key in this.data.data) {
				let d = this.data.data[key];
				if (d.type == 'Buildin' || d.type == 'Select' || d.type == 'Radio') {
					data.data[key] = this.actions.getTextByOptionID(d.dfield, data.data[key]);
				}
			}
			data.change_fields = this.data.postData;
			if (!_.isEmpty(this.data.buildin_fields)) {
				data.buildin_fields = this.data.buildin_fields;
			}
			if (this.data.isSongCount) {
				data.child_table_id = this.data.sonTableId;
				data.record_id = this.data.sonTableId;
			}
			let res = await FormService.getAllCountData(data);
			this.actions.setValueFromDataForForm(res);
			this.actions.afterGetDataForForm();
		},

		setValueFromDataForForm(res) {
			for (let k in res["data"]) {
				if(res["data"][k]===null){
                    res["data"][k]='';
				}
				let data = this.data.data;
				//如果是周期规则
				if (data.hasOwnProperty(k) && data[k].hasOwnProperty("real_type") && data[k]["real_type"] == '27') {
					if (res["data"][k]["-1"]) {
						this.actions.setFormValue.bind(this)(k, res["data"][k]["-1"], false, true);
					}
				} else {
					this.actions.setFormValue.bind(this)(k, res["data"][k], false, true);
				}
			}
		},

		afterGetDataForForm() {
			this.data.buildin_fields = {};
			this.data.child_table_id = '';
			this.data.postData = [];
			this.data.isSongCount = false;
			this.actions.afterCalc();
			this.data.isInit = false;
			setTimeout(() => {
                this.data && (this.data.SongridRef = false);
			}, 3000);
		},

		//移除其它字段隐藏的字段信息
		checkOhterField(data, obj_new, obj_old) {
			if (this.data['show_other_fields']) {
				return;
			}
			let delKey = [];
			for (let index in this.data.data) {
				if (this.data.data[index]['is_other_field'] && this.data.submitKey.indexOf(this.data.data[index]['id']) == -1) {
					delKey.push(this.data.data[index]['dfield']);
				}
			}
			for (let obj of delKey) {
				if (data) {
					delete data[obj];
				}
				if (obj_new) {
					delete obj_new[obj];
				}
				if (obj_old) {
					delete obj_old[obj];
				}
			}
		},

		//密码框回显
		addEnrypt(data,type) {
			let value = data.newItems;
			if(type){
				value = this.actions.md5(value);
			}
			let psField = this.data['addPassWordField'];
			this.data.data[psField].value = value;
			if (this.data.isWX) {
				this.data.newControl.actions.hasChangeValue(this.data.data[psField]);
			} else {
				this.data.childComponent[psField].actions.hasChangeValue(this.data.data[psField]);
			}
		},

		createSubmitPostJson(formValue) {
			let data = this.actions.handleFormData(formValue);
			let formDataOld = this.data.oldData;
			//如果有其他字段的数据，这里是拼approvedFormData
			this.actions.checkDateType(formValue);
			let obj_new = this.actions.createCacheData(formDataOld, data, true, this);
			let obj_old = this.actions.createCacheData(formDataOld, data, false, this);
			this.actions.changeValueForChildTable(data);
			if (this.data.hasOtherFields == 0) {
				this.actions.checkOhterField(data, obj_new, obj_old);
			}
			let json = {
				data: JSON.stringify(data),
				cache_new: JSON.stringify(obj_new),
				cache_old: JSON.stringify(obj_old),
				table_id: this.data.tableId,
				flow_id: this.data.flowId,
				focus_users: this.data.focusUsers || '[]',
				parent_table_id: this.data.parentTableId || "",
				parent_real_id: this.data.parentRealId || "",
				parent_temp_id: this.data.parentTempId || "",
				parent_record_id: this.data.parentRecordId || ""
			};
			//如果是批量审批，删除flow_id
			if (this.data.isBatch == 1) {
				delete json["flow_id"];
			}
			if (this.data.isAddBuild) {
				json['buildin_id'] = this.data.buildId;
			}
			//新增时传参作为参数使用
			if (window.config.btnType == 'new') {
				json['isNew'] = 1;
			}
			return json;
		},
		//提交表单数据
		async onSubmit() {
			if (!this.data.data['real_id']['value'] && window.top.miniFormVal) {
				delete window.top.miniFormVal[this.data.data['table_id']['value']];
			} else {
				window.top.miniFormValRealId = '';
			}
			let formValue = this.actions.createFormValue(this.data.data);
			let {error, errorMsg} = this.actions.validForm(this.data.data, formValue);
			if (error) {
				MSG.alert(errorMsg);
				this.data.isBtnClick = false;
				return;
			}
			let json = this.actions.createSubmitPostJson(formValue);
			let res = await FormService.saveAddpageData(json);
			if (res.succ == 1) {
				if(res.task_error_msg) MSG.alert(res.task_error_msg);
				this.actions.submitSuccessCb(res);
                Mediator.publish('calendar-save-success','');
                //日历新建表单提交成功  通知日历刷新
                Mediator.emit('submitNewlybuild',this.data)
			} else {
				MSG.alert(res.error);
			}
            this.data && (this.data.isBtnClick = false);
		},

		submitSuccessCb(res) {
			MSG.showTips('保存成功');
			Mediator.publish('updateForm:success:' + this.data.tableId, true);
			if(this.data.key){
                if (this.data.isAddBuild && !this.flowId) {
                    PMAPI.sendToRealParent({
                        type: PMENUM.close_dialog,
                        key: this.data.key,
                        data: {new_option: res.new_option},
                    });
                } else {
                    PMAPI.sendToRealParent({
                        type: PMENUM.close_dialog,
                        key: this.data.key,
                        data: 'success',
                    });
                }
			}
			//清空子表内置父表的ids
			delete window.top.idsInChildTableToParent[this.data.tableId];
		},

		createPostJson() {
			let json;
			//如果是发起工作流
			if (this.data.fromWorkFlow && this.data.realId == '') {
				json = {
					form_id: this.data.formId,
					record_id: this.data.recordId,
					reload_draft_data: this.data.reloadDraftData,
					from_workflow: this.data.fromWorkFlow,
					table_id: this.data.tableId
				}
			} else if (this.data.fromApprove && this.data.realId == '') {//审批流程
				json = {
					form_id: this.data.formId,
					record_id: this.data.recordId,
					is_view: this.data.isView,
					from_approve: this.data.fromApprove,
					from_focus: this.data.fromFocus,
					table_id: this.data.tableId
				}
			}
			else {
				json = this.actions.pickJson();
			}
			if (this.data.fromWorkFlow) {
				json['from_workflow'] = this.data.fromWorkFlow;
			}
			if (this.data.fromApprove) {
				json['from_approve'] = this.data.fromApprove;
			}
			return json;
		},
		//非工作流请求json
		pickJson() {
			let json = {};
			if (this.data.fieldId !== "") {
				//加载单元格数据
				json = {
					field_id: this.data.fieldId,
					is_view: this.data.isView,
					parent_table_id: this.data.parentTableId || "",
					parent_real_id: this.data.parentRealId || "",
					parent_temp_id: this.data.parentTempId || ""
				}
			} else {
				//加载表单中所有数据，当有form_id时，不要为table_id赋值，保证缓存的可复用性
				if (this.data.formId) {
					json = {
						form_id: this.data.formId,
						table_id: this.data.tableId,
						is_view: this.data.isView,
						parent_table_id: this.data.parentTableId || "",
						parent_real_id: this.data.parentRealId || "",
						parent_temp_id: this.data.parentTempId || ""
					}
				} else {
					json = {
						form_id: "",
						table_id: this.data.tableId,
						is_view: this.data.isView,
						parent_table_id: this.data.parentTableId || "",
						parent_real_id: this.data.parentRealId || "",
						parent_temp_id: this.data.parentTempId || ""
					}
				}
			}
			this.actions.checkTemp(json);
			return json;
		},

		checkTemp(json) {
			//如果是临时表，传temp_id，否则是real_id
			if (this.data.inProcess == 1 || this.data.isBatch == 1) {
				json["temp_id"] = this.data.realId;
			} else {
				json["real_id"] = this.data.realId;
			}
			if (this.data.tempId) {
				json["temp_id"] = this.data.tempId;
				if (json["real_id"]) {
					delete json["real_id"];
				}
			}
		},

		checkCustomTable() {
			if (this.data.custom_table_form_exists) {
				if (this.data.table_name == '人员信息') {
					for (let key in this.data.data) {
						if (this.data.data[key].label == '用户名') {
							this.data.data[key].is_view = 1;
							this.data.childComponent[key].data.is_view = 1;
							this.data.childComponent[key].reload();
						}
					}
				}
			}
		},

		//转到编辑模式
		async changeToEdit() { //重新获取动态数据 （temp_id会变）
			window.config.btnType = 'edit'
			this.data.isView = 0;
			//查看转编辑子表请求数据
			window.config['view_finish_data'] = 0;
			let json = this.actions.createPostJson();
			let res = await FormService.getDynamicData(json);
            //判断投顾人员信息信息表编辑禁用主岗部门用户名和姓名
            if (this.data.tableId == '8424_aSioYxg4zFMTthw3GZpfdc') {
                res.data['f5']['is_view'] = 1;
                res.data['f6']['is_view'] = 1;
                res.data['f12']['is_view'] = 1;
                this.el.find('.touguName').addClass('touguDisable')
            }
			for (let key in res.data) {
				if (res.data[key].options) {
					if (!~['Buildin', 'MultiSelect'].indexOf(this.data.data[key].type)) {
						if (!this.data.data[key].options) {
							this.data.data[key].options = [];
						}
						res.data[key].options = this.data.data[key].options.concat(res.data[key].options);
					} else {
						delete res.data[key].options;
					}
				}
				if(res.data[key].dataList){
					delete res.data[key].dataList;
				}
				if (this.data.data[key].type == "Correspondence") {
					res.data[key]['parent_real_id'] = res.data['real_id'].value;
					res.data[key]['parent_table_id'] = res.data['table_id'].value;
					res.data[key]['parent_temp_id'] = res.data['temp_id'].value;
					res.data[key]['temp_id']=res.data['temp_id'].value;
				}
				this.data.data[key] = Object.assign({}, this.data.data[key], res.data[key]);
                this.actions.setAccuracy(this.data.data[key]);
				if (this.data.childComponent[key]) {
					this.data.childComponent[key].data = Object.assign({}, this.data.childComponent[key].data, res.data[key]);
                    this.actions.setAccuracy(this.data.childComponent[key].data);
					try {
						this.data.childComponent[key].reload();
					} catch (e) {
						console.log(e);
					}
					setTimeout(() => {
						this.actions.reviseCondition(this.data.data[key], this.data.data[key].value);
					}, 0);
				}
			}
			this.actions.afterChangeToEdit();
		},
		async afterChangeToEdit() {
			if (this.data.isOtherChangeEdit) {

				this.data.btnType = 'none';
			} else {
				this.data.btnType = 'new';
			}
			this.actions.addBtn();
			this.actions.checkCustomTable();
			this.data.isInit = true;
			this.actions.setDataFromParent();
			await this.actions.firstGetData();
            this.actions.getOptions();
			this.data.isBtnClick = false;
		},
		//修改可修改性
		reviseCondition: function (editConditionDict, value) {
			// if(this.dfService.isView){return false;}
			let arr = [];
			let flag = false;
			let keyNum;
			for (let key in editConditionDict["edit_condition"]) {
				if (key == 'and') {
					this.actions.andReviseCondition(editConditionDict, key, value);
				} else {
					if (key == value) {
						flag = true;
						keyNum = key;
					}
					this.actions.otherReviseCondition(editConditionDict, key, arr, value);
				}
			}
			if (flag) {
				this.actions.otherReviseCondition(editConditionDict, keyNum, arr, value);
			}
		},

		otherReviseCondition(editConditionDict, key, arr, value) {
			if (key != 'term') {
				for (let dfield of editConditionDict["edit_condition"][key]) {
					if (arr.indexOf(dfield) != -1) {
						continue;
					}
					//如果有字段的负责性，再开始下面的逻辑
					let data = this.data.data[dfield];
					if (this.data.data[dfield]["required_perm"] == 1) {
                        let keyData = editConditionDict["edit_condition"];
                        this.actions.selectReviseCondition(data, value, key, keyData, arr, dfield);
						// this.actions.selectReviseCondition(data, value, key, arr, dfield);
					}
					if (this.data.childComponent && this.data.childComponent[dfield]) {
						// data.value = '';
						this.data.childComponent[dfield].data = data;
						this.data.childComponent[dfield].reload();
						// this.actions.checkValue(data);
					}
				}
			} else {
				this.actions.editConditionChangeRequiredPermByTerm(editConditionDict, value, key)
			}

		},

		selectReviseCondition(data, value, key, keyData, arr, dfield) {
			//针对多选下拉框，只要包含就可以
			if (value instanceof Array) {
                let identicalId = [];//满足的id
				for (let k in keyData) {
					if ((keyData[k]instanceof Array) && keyData[k].indexOf(dfield) != -1 && value.indexOf(k) != -1) {
                        identicalId.push(k)
					}
				}
                //多选框    只要有一个满足就可以
                if (identicalId.length > 0) {
                    data["be_control_condition"] = 0;
                } else if (value.length == 0) {
                    data["be_control_condition"] = 1;
                } else {
                    data["be_control_condition"] = 1;
                }
                // data['be_control_condition'] = value.indexOf(key) != -1 ? 0 : 1;
			} else {
				data["be_control_condition"] = (key == value) ? 0 : 1;
			}
			if (this.data.data[data.dfield]) {
				this.data.data[data.dfield] = _.defaultsDeep({}, data);
			}
		},

		//根据editCondition中的term来进行负责性的修改
		editConditionChangeRequiredPermByTerm(editConditionDict, value, key, arr, dfield) {
			for (let dfield in editConditionDict["edit_condition"][key].data) {
				let data = this.data.data[dfield];
				let flag = false;
                let eqname = [];//文本类型   满足得条件字段
                let neqName = [];//文本类型    不满得条件字段
                //如果是数字类型得    and情况
                if (editConditionDict.real_type == '26' || editConditionDict.real_type == '10' || editConditionDict.real_type == '11') {

                } else {
                	//不是数组类型的  and情况
					for (let k = 0; k < editConditionDict["edit_condition"][key].data[dfield].length; k++) {
						if (editConditionDict["edit_condition"][key].data[dfield][k].k == 'eq') {//等于的字段
                            eqname.push(editConditionDict["edit_condition"][key].data[dfield][k].v);
						} else if (editConditionDict["edit_condition"][key].data[dfield][k].k == 'neq') {//不等于的字段
                            neqName.push(editConditionDict["edit_condition"][key].data[dfield][k].v);
						}
					}
                }
				for (let data of editConditionDict["edit_condition"][key].data[dfield]) {
                    //判断条件为或   或者  为空  都走或者的关系
                    if (editConditionDict["edit_condition"][key].relation_mapping[dfield] != 'and') {
                        if (data.k == 'eq') {
                            if (editConditionDict.type == 'Buildin') {    //内置字段用selectLabel判断值是否相等
                                if (editConditionDict.selectLabel == data.v) {
                                    flag = true;
                                }
                            }else if (editConditionDict.type == 'MultiSelect') {//多选内置字段用multiSelectLabel判断数组是否相等
								this.actions.multiSelectData(editConditionDict);
                                if (editConditionDict.multiSelectLabel) {
                                    for (let h = 0; h < editConditionDict.multiSelectLabel.length; h++) {
                                        if (eqname.indexOf(editConditionDict.multiSelectLabel[h]) != -1) {
                                            flag = true;
                                        }
                                    }
                                }
                            } else if (value == data.v) {
                                flag = true;
                            }
                        } else if (data.k == 'neq') {
                            if (editConditionDict.type == 'Buildin') {    //内置字段用selectLabel判断值是否相等
                                if (editConditionDict.selectLabel != data.v) {
                                    flag = true;
                                }
                            }else if (editConditionDict.type == 'MultiSelect') {//多选内置字段用multiSelectLabel判断数组是否相等
                                this.actions.multiSelectData(editConditionDict);
                            	if (editConditionDict.multiSelectLabel) {
                                    for (let h=0;h<editConditionDict.multiSelectLabel.length;h++) {
                                        if (neqName.indexOf(editConditionDict.multiSelectLabel[h]) == -1) {
                                            flag = true;
                                        }
                                    }
								}
                            } else if (value != data.v) {
                                flag = true;
                            }
                        }
                        if (editConditionDict.real_type == '26' || editConditionDict.real_type == '10' || editConditionDict.real_type == '11') {
                            let val = Number(value);
                            if (val || val == 0) { //为0的情况也得验证
                                if (data.k == 'gt') {
                                    if (val > data.v) {
                                        flag = true;
                                    }
                                } else if (data.k == 'gte') {
                                    if (val >= data.v) {
                                        flag = true;
                                    }
                                } else if (data.k == 'lt') {
                                    if (val < data.v) {
                                        flag = true;
                                    }
                                } else if (data.k == 'lte') {
                                    if (val <= data.v) {
                                        flag = true;
                                    }
                                }
                            }
                        }
                    } else {
                        //判断条件为与的时候
                        if (data.k == 'eq') {
                            if (editConditionDict.type == 'Buildin') {//内置字段用selectLabel判断值是否相等
                                //单选内置条件不满足就直接跳出循环  等于（eqname）的条件只能有一个  否则不通过
                                if (neqName.indexOf(editConditionDict.selectLabel) == -1 && eqname.indexOf(editConditionDict.selectLabel) == 0 && eqname.length == 1) {
                                    flag = true;
                                } else {
                                    flag = false;
                                    break;
                                }
                            } else if (editConditionDict.type == 'MultiSelect') {//多选内置字段用multiSelectLabel判断数组是否都包含了  eqname
                                this.actions.multiSelectData(editConditionDict);
                                if (editConditionDict.multiSelectLabel) {
                                    let eqVauleName = [];
                                    for (let i=0;i<editConditionDict.multiSelectLabel.length;i++) {
                                        if (eqname.indexOf(editConditionDict.multiSelectLabel[i]) != -1) {
                                            eqVauleName.push(editConditionDict.multiSelectLabel[i]);
                                        }
                                    }
                                	if (eqVauleName.length === eqname.length) {
                                		flag = true;
									} else {
                                        flag = false;
                                        break;
									}
								} else {
                                    flag = false;
                                    break;
                                }
							}else if (eqname.indexOf(value) != -1) {
                                flag = true;
                            } else {
                                flag = false;
                                break;
							}
                        } else if (data.k == 'neq') {
                            if (editConditionDict.type == 'Buildin') {//内置字段用selectLabel判断值是否相等
                            	//单选内置条件不满足就直接跳出循环  等于的条件只能有一个  否则不通过
                                if (neqName.indexOf(editConditionDict.selectLabel) == -1 && eqname.indexOf(editConditionDict.selectLabel) == 0 && eqname.length == 1) {
                                    flag = true;
                                }else if (neqName.indexOf(editConditionDict.selectLabel) == -1 && eqname.length == 0){
                                    flag = true;
								} else {
                                    flag = false;
                                    break;
								}
                            }  else if (editConditionDict.type == 'MultiSelect') {//多选内置字段用multiSelectLabel判断数组是否包含了不等于的值   neqName
                                this.actions.multiSelectData(editConditionDict);
                                if (editConditionDict.multiSelectLabel) {
                                    let neqVauleName = [];
                                	for (let k=0;k<neqName.length;k++) {
                                       if(editConditionDict.multiSelectLabel.indexOf(neqName[k]) != -1) {
                                           neqVauleName.push(neqName[k]);
									   }
									}
                                    if (neqVauleName.length === 0 ) {
                                        flag = true;
                                    } else {
                                        flag = false;
                                        break;
                                    }
                                } else {
                                    flag = false;
                                    break;
								}
                            }else if (neqName.indexOf(value) == -1) {
                                flag = true;
                            } else {
                                flag = false;
                                break;
                            }
                        }
                        if (editConditionDict.real_type == '26' || editConditionDict.real_type == '10' || editConditionDict.real_type == '11') {
                            //为数字类型的的时候   要同时满足条件
                            let val = Number(value);
                            if (val || val == 0) {//为0的情况也得验证
                                if (data.k == 'gt') {
                                    if (val > data.v) {
                                        flag = true;
                                    } else {
                                        flag = false;
                                        break;
									}
                                } else if (data.k == 'gte') {
                                    if (val >= data.v) {
                                        flag = true;
                                    } else {
                                        flag = false;
                                        break;
                                    }
                                } else if (data.k == 'lt') {
                                    if (val < data.v) {
                                        flag = true;
                                    } else {
                                        flag = false;
                                        break;
                                    }
                                } else if (data.k == 'lte') {
                                    if (val <= data.v) {
                                        flag = true;
                                    } else {
                                        flag = false;
                                        break;
                                    }
                                }
                            }
                        }
					}
				}
				if (this.data.data[dfield]["required_perm"] == 1) {
					data["be_control_condition"] = (flag) ? 0 : 1;
					if (this.data.data[data.dfield]) {
						this.data.data[data.dfield] = _.defaultsDeep({}, data);
					}
				}
				if (this.data.childComponent && this.data.childComponent[dfield]) {
					this.data.childComponent[dfield].data = data;
					this.data.childComponent[dfield].reload();
					// this.actions.checkValue(data);
				}
			}
		},

		andReviseCondition(editConditionDict, key, value) {
			let andData = editConditionDict["edit_condition"][key];
			for (let f in andData) {
				let i = 0;
				for (let d of andData[f]) {
					if (value instanceof Array) {
						for (let b of value) {//与的情况  多个条件
							if (d == b) {
								i++;
							}
						}
					} else {
						if (d == value) {//与的情况  单个条件
							i++;
						}
					}

				}
				//为查看模式    只能查看不能编辑
				if (window.config.btnType === 'view') {
					this.data.data[f]["is_view"] = 1;
				} else {
					this.data.data[f]["is_view"] = (i == andData[f].length) ? 0 : 1;
					//满足条件   可修改
					this.data.data[f]["be_control_condition"] = (i == andData[f].length) ? 0 : 1;
				}
                setTimeout(() => {
					this.data.childComponent[f].data = this.data.data[f];
                	this.data.childComponent[f].reload();
				}, 100);
			}
		},

		//多选内置  查看  编辑的时候  值验证
        multiSelectData (editConditionDict) {
            if ((window.config.btnType === 'view' || window.config.btnType === 'edit') && !editConditionDict.multiSelectLabel) {
                let dataArr = [];
                for(let key in editConditionDict.options){
                	for (let k in editConditionDict.value) {
                		if (editConditionDict.value[k] === editConditionDict.options[key].value) {
                            dataArr.push(editConditionDict.options[key]['label']);
						}
					}
                }
				editConditionDict.multiSelectLabel = dataArr;
			}
		},

		checkAboutData(data) {
			let id = data["id"];
			let value;
			if (data.type == 'Buildin') {
				for (let obj of data['options']) {
					if (data.value == '') {
						value = '';
						break;
					}
					if (obj.value == data.value) {
						value = obj.value;
						break;
					}
				}
			} else {
				value = data.value;
			}
			this.actions.setAboutData(id, value);
		},

		checkDefaultValue(data, defaultValue) {
			if (this.data.flowId != "" && this.data['base_fields'].indexOf(data["dfield"]) != -1 && defaultValue) {
				if (data.type == 'Input') {
					if (!this.data.timer) {
						this.data.timer = setTimeout(() => {
							this.actions.validDefault(data, data['value']);
							this.data.timer = null;
						}, 3000);
					} else {
						clearTimeout(this.data.timer);
						this.data.timer = setTimeout(() => {
							this.actions.validDefault(data, data['value']);
							this.data.timer = null;
						}, 3000);
					}
				} else {
					this.actions.validDefault(data, data['value']);
				}
			}
		},

		checkChangeOptions(data) {
			if (!_.isEmpty(data['linkage'])) {
				let j = 0;
				let arr = [];
				for (let value in data['linkage']) {
					for (let k in data['linkage'][value]) {
						arr.push(k);
					}
					if (value == data['value']) {
						j++;
						//改变选择框的选项
						this.actions.changeOptionOfSelect(data, data['linkage'][value]);
					}
				}
				if (j == 0) {
					let obj = FormService.selectObj;
					for (let field of arr) {
						this.data.data[field][obj[this.data.data[field]['type']]] = this.data.optionsToItem[field];
						this.data.childComponent[field] && (this.data.childComponent[field].data[obj[this.data.data[field]['type']]] = this.data.optionsToItem[field]) && this.data.childComponent[field].reload();
					}
				}
			}
		},
		//检查是否修改必填
		checkRequiredCondition(){
			//修改必填性功能
			for(let key in this.data.data){
				let data=this.data.data[key];
				if (data["required_condition"] && data["required_condition"] !== "") {
					this.actions.requiredCondition(data, data['value']);
				}
				if (data["required_condition"] && data["required_condition"] !== "") {
					this.actions.requiredCondition(data, data['value']);
				}
			}
		},
		//触发事件检查
		checkValue: async function (data, noCount, defaultValue) {
			let isPustToPostData1 = false;
			let isPustToPostData2 = false;
			if ((this.data.childComponent && !this.data.childComponent[data.dfield]) && !this.data.isWX) {
				return;
			}
			if (this.data.data[data.dfield]) {
				this.data.data[data.dfield] = _.defaultsDeep({}, data);
			}
			if ((data.type == 'Buildin' || data.type == 'MultiLinkage') && !this.data.isInit && !noCount) {
				this.actions.checkAboutData(data);
			}
			//检查是否是默认值的触发条件
			// if(this.flowId != "" && this.data.baseIds.indexOf(data["dfield"]) != -1 && !isTrigger) {
			this.actions.checkDefaultValue(data, defaultValue);
			//统计功能
			this.actions.myUseFieldsofcountFunc();
			if (!noCount) {
				isPustToPostData2 = this.actions.countFunc(data.dfield);
			}
            if (data.required && !this.data.isWX) {
                this.actions.requiredChange(this.data.childComponent[data.dfield]);
            }
			//改变选择框的选项
			if (!this.data.isInit) {
				this.actions.checkChangeOptions(data);
			}
			//修改负责
			if (data["edit_condition"] && data["edit_condition"] !== "") {
				setTimeout(() => {
					this.actions.reviseCondition(data, data.value);
				}, 0);
			}
			if (data["required_condition"] && data["required_condition"] !== "") {
				this.actions.requiredCondition(data, data['value']);
			}

			if (!noCount) {
				isPustToPostData1 = this.actions.webCalcExpression(data)
			} else {
				this.actions.webCalcExpression(data);
			}
			if (!this.data.isInit && (isPustToPostData1 || isPustToPostData2)) {
                if (this.data.postData.length == 0){
                    this.data.postData.push(data.dfield)
                }
                else {
                    for (var  item of this.data.postData) {
                        if (item != data.dfield) {
                            this.data.postData.push(data.dfield);
                        }else {
                            return false;
                        }
                    }
                }
			}
			if (this.data["frontend_cal_parent_2_child"]) {
				this.actions.saveParentFormValue();
			}
			if (!this.data.isInit && !noCount) {
				this.actions.getDataForForm();
            }
		},

		replaceSymbol(data) {
			let reg = /\@f\d+\@/g;
			let items = data.match(reg);
			let str_ = data.indexOf("\"else\"") != -1 ? ('\\\"') : ('\"');
			let formValue = this.actions.createFormValue(this.data.data);
			for (let item of items) {
				item = item.replace("@", "").replace("@", "");
				let v = formValue[item];
				let num = formValue[item]
				let flag = false;
				if (typeof(num) == 'string') {
					flag = true;
				}
				else {
					flag = false;
				}
				if (flag == true) {
					if (num.indexOf(",") != -1 && num.replace(/,/g, "") == parseInt(num.replace(/,/g, ""))) {
						if (num.indexOf(".0") == -1) {
							v = v.replace(/,/g, "") + ".0";
						} else {
							v = v.replace(/,/g, "")
						}
					}
					if (data.indexOf('count_time_sum') != -1 && num.indexOf('T') != -1) {
						v = v.replace(/T/g, " ");
					}
				}
				let isUndefined = false;
				if (v == undefined) {
					isUndefined = true;
				}
				let type = "";
				let dinput_type = "";
				if (this.data.data[item].hasOwnProperty("real_type")) {
					type = this.data.data[item]["real_type"];
				}
				if (this.data.data[item].hasOwnProperty("dinput_type")) {
					dinput_type = this.data.data[item]["dinput_type"];
				}
				if (FIELD_TYPE_MAPPING.SELECT_TYPE.indexOf(dinput_type) != -1) {
					//枚举类型 or 各种内置
					v = this.actions.getTextByOptionID(item, formValue[item]);
				}
				if (FIELD_TYPE_MAPPING.NUMBER_TYPE.indexOf(type) != -1) {
					//整数或者小数处理下去掉，解决发起工作流回显为空的bug
					try {
						v = v.replace(/,/g, "")
						//整数或者小数
						v = v === "" ? 0 : v;
					} catch (e) {
					}
				} else {
					v = (v === "") ? (str_ + str_) : (str_ + v + str_);
				}
				if (isUndefined) {
					data = data.replace("@" + item + "@", '\\\"\\\"');
				} else {
					data = data.replace("@" + item + "@", v);
				}
				if (fieldTypeService.DATETIME == dinput_type) {
					v = v.replace("T", " ");
				}
				data = data.replace("@" + item + "@", v);
			}
			data = data.replace(/\#/g, 'this.');
			return data;
		},

		afterCalc() {
			for (let f in this.data.webCalc) {
				try {
					let expressionStr = this.data.webCalc[f];
					let expression = this.actions.replaceSymbol(expressionStr)
					expression = expression.replace(/this/, 'FormService')
					this.actions.set_value_for_form(eval(expression), f);
				} catch (err) {
					delete this.data.webCalc[f];
				}
			}
			this.data.webCalc = {};
		},

		webCalcExpression(data, FormService) {
			let calcData = {
				val: data['value'],
				effect: data["effect"],
				id: data['id']
			};
			let isCalc;
			for (let index in data["effect"]) {
				let f = data["effect"][index];
				let expression;
				let bool = false;
				if (this.data.data.hasOwnProperty(f)) {
					let expressionStr = this.data.data[f]["expression"];
					if (expressionStr !== "") {
						expression = this.actions.replaceSymbol(expressionStr);
						try {
							if (expression.indexOf("$^$") == -1) {
								try {
									// if (this.data.data[expressionStr.split("@")[1]]["is_view"] != 1) {
									expression = expression.replace(/this/, 'FormService')
									this.data.webCalc[f] = expressionStr;
									isCalc = true;
									// }
								} catch (err) {
									console.log('不能执行前端表达式计算');
									bool = true;
								}
							} else {
								bool = true;
							}
						} catch (err) {
							console.log('不能执行前端表达式计算');
							bool = true;
						}
					} else {
						bool = true;
					}
				} else {
					bool = true;
				}
				if (bool) {
					isCalc = this.actions.calcExpression(calcData, data['value'])
				}
			}
			return isCalc;
		},
		//小数显示精度
		showAccuracy(dfield, value) {
			let data = this.data.data[dfield];
			if (data) {
				if (FIELD_TYPE_MAPPING.NUMBER_TYPE.indexOf(data["real_type"]) != -1) {
					value = new Number(value);
					let accuracy = data["accuracy"];
					value = value.toFixed(accuracy);
				}
				return value;
			}
			return value;
		},
		//添加按钮组
		addBtn() {
			this.el.find('.ui-btn-box').remove();
			//添加提交按钮
			// let $wrap = this.el.find('table').parentsUntil(this.data.el);
			let $wrap = this.el;
			if (this.data.btnType == 'new' || this.data.btnType == 'edit') {
				this.actions.btnNew($wrap);
			} else if (this.data.btnType == 'view') {
				this.actions.btnView($wrap);
			} else if (this.data.btnType == 'none') {

			} else if (this.data.btnType == 'confirm') {
				this.actions.btnConfirm($wrap);
			}
		},

		btnConfirm($wrap) {
			$wrap.append(`<div class="noprint ui-btn-box"><div >
                    <button class="btn btn-normal">
                        <span>确定</span>
                        <div class="btn-ripple ripple"></div>
                    </button>
                </div></div>`)
		},

		btnView($wrap) {
			$wrap.append(`<div class="noprint ui-btn-box"><div >
                    <!--<button class="btn btn-normal mrgr" id="print" >-->
                        <!--<span>打印</span>-->
                        <!--<div class="btn-ripple ripple"></div>-->
                    <!--</button>-->
                    <button class="btn btn-normal changeEdit" >
                        <span>转到编辑</span>
                        <div class="btn-ripple ripple"></div>
                    </button>
                </div></div>`)
		},

		btnNew($wrap) {
			$wrap.append(`<div class="noprint ui-btn-box"><div>
                    <!--<button class="btn btn-normal mrgr" id="print">-->
                        <!--<span>打印</span>-->
                        <!--<div class="btn-ripple ripple"></div>-->
                    <!--</button>-->
                    <button class="btn btn-normal ceshi save" >
                        <span>提交</span>
                        <div class="btn-ripple ripple"></div>
                    </button>
                </div></div>`)
		},

		//创建events函数
		createActions() {
			let actions = {
				openGetUsers: (data, events) => {
                    this.actions.openGetUsers(data, events);
				},
                selectPostMessageUserCb: (dfield, data) => {
                    this.actions.selectPostMessageUserCb(dfield, data);
				},
				changeValue: (data) => {
					this.actions.checkValue(data, false, true);
				},
				emitHistory: (data) => {
					this.actions.openHistoryDialog(data);
				},
				openCorrespondence: (data) => {
					this.actions.openCorrespondence(data);
				},
				openSongGrid: (data, url) => {
					this.actions.openSongGrid(data, url);
				},
				changeOption: (data) => {
					this.actions.changeOption(data);
				},
				addItem: (data) => {
					this.actions.addItem(data);
				},
				addPassword: (data) => {
					this.actions.addPassword(data);
				},
				selectChoose: (data) => {
					this.actions.selectChoose(data);
				},
				addNewBuildIn: (data) => {
					this.actions.addNewBuildIn(data);
				},
				userSysOptions: (data) => {
					this.actions.changeMainDepart(true, data);
				},
				emitOpenCount: (data) => {
					this.actions.openCount(data);
				},
				emitDataIfInline: (data) => {
					this.actions.emitDataIfInline(data);
				},
				CorrespondenceRequiredChange: (data) => {
					this.actions.CorrespondenceRequiredChange(data);
				},
                selectChooseMulti: (data) => {
                    this.actions.selectChooseMulti(data);
                }
			}
			return actions;
		},
		//对应关系必填改变
		CorrespondenceRequiredChange(data) {
			this.data.data[data.dfield].correspondenceHasValue = data.correspondenceHasValue;
		},
		//内联子表刷新事件
		emitDataIfInline(data) {
			this.data.can_not_open_form = data.can_not_open_form;
			let type = data["type"];
			let isView = data["is_view"];
			if (type == 'popup') {
				this.data.sonTableId = data["value"];
				if (isView == '0') {
					this.data.viewMode = 'normal';
				} else {
					this.data.viewMode = 'viewFromSongrid';
				}
			} else {
				this.data.sonTableId = data["value"];
				if (isView == '0' && !this.data.SongridRef && !this.data.isInit && !data.isInit) {
					this.data.SongridRef = true;
					this.actions.setCountData(data.dfield);
				}
			}
			//保存父表数据
			this.data.data[data['dfield']].total = data['total'];
			this.actions.saveParentFormValue();
		},
		//打开统计穿透
		openCount(data) {
			let childId = data['field_content']['count_table'];
			let showName = `${this.data['table_name']}->${data['field_content']['child_table_name']}`;
			if (this.data.realId) {
				PMAPI.openDialogByIframe(`/iframe/sourceDataGrid/?tableName=${showName}&parentTableId=${this.data.tableId}&viewMode=count&tableId=${childId}&rowId=${this.data.realId}&tableType=count&fieldId=${data.id}`, {
					title: showName,
					width: 1400,
					height: 810,
				})
			} else {
				let formValue = this.actions.getFormValue();
				let d = {
					table_id: this.data.tableId,
					data: JSON.stringify(formValue),
					field_id: data.id
				};
				PMAPI.openDialogByIframe(`/iframe/sourceDataGrid/?viewMode=newFormCount&tableId=${childId}&fieldId=${data.id}`, {
					title: showName,
					width: 1400,
					height: 810,
				}, {d});
			}
		},
		//打开内置快捷添加
		addNewBuildIn(data, w, h) {
			let _this = this;
			_this.data['quikAddDfield'] = data.dfield;
			if (window.innerWidth < 1300) {
				w = 900;
				h = 600;
			}
			PMAPI.openDialogByIframe(`/iframe/addWf/?table_id=${data.source_table_id}&isAddBuild=1&id=${data.id}&key=${this.key}&btnType=new`, {
				width: w || 1400,
				height: h || 810,
				title: `快捷添加内置字段`,
				modal: true
			}).then((data) => {
				if (!data.new_option) {
					return;
				}
				_this.actions.addNewBuildCb(data);
			});
		},

		addNewBuildCb(data) {
			let options = this.data.childComponent[this.data['quikAddDfield']].data['options'];
			//默认选中新添加选项
			if (options.length > 0 && (options[0]['label'] == '请选择' || options[0]['label'] == '')) {
				options.splice(1, 0, data.new_option);
			} else {
				options.splice(0, 0, data.new_option);
			}
			this.data.childComponent[this.data['quikAddDfield']].data.value = data.new_option.value;
			this.data.childComponent[this.data['quikAddDfield']].data.showValue = data.new_option.label;
			this.data.data[this.data['quikAddDfield']] = this.data.childComponent[this.data['quikAddDfield']].data;
			this.data.childComponent[this.data['quikAddDfield']].reload();
			this.actions.triggerControl();
		},

		//打开选择器
		selectChoose(data, w, h) {
			let _this = this;
			if (window.innerWidth < 1300) {
				w = 900;
				h = 600;
			}
			PMAPI.openDialogByIframe(`/iframe/choose/?fieldId=${data.id}&key=${this.data.key}`, {
				width: w || 1400,
				height: h || 810,
				title: `选择器`,
				modal: true,
                iszoom:true,
			}, {
				data: data
			}).then((res) => {
				if (res.value) {
					_this.actions.selectChooseCb(res, data);
				}
			});
		},

        //打开选择器-多选内置
        selectChooseMulti(data, w, h) {
            let _this = this;
            if (window.innerWidth < 1300) {
                w = 900;
                h = 600;
            }
            PMAPI.openDialogByIframe(`/iframe/chooseMulti/?fieldId=${data.id}&key=${this.data.key}&tableId=${this.data.tableId}&source_table_id=${data.source_table_id}`, {
                width: w || 1400,
                height: h || 810,
                title: `选择器`,
                modal: true,
                iszoom:true,
            },{
                dfield:data.dfield,
                value:data.value
            }).then((res) => {
                if(res && !res.onlyclose && !res.isError) {
                    this.actions.selectMultiChooseCb(res.selected, data);
                }
            });
        },
		 /**
         * 打开选择人员列表
         */
        openGetUsers(data, events) {
            PMAPI.openDialogByIframe('/iframe/PostMessageGetUsers',{
                width: 540,
                height: 660,
                maxable: false,
                title: '选择人员',
                iszoom:true,
            },{
                data:data.departmentData,
                choosedUsers:data.choosedUsers
            }).then(res=>{
                if(!res.onlyclose){
                    let choosedUsers = res.choosedUsers.map((item) => {
                        return item.id;
                    });
                    let choosedUsersName = res.choosedUsers.map((item) => {
                        return item.name;
                    });
                    this.actions.selectPostMessageUserCb(data.dfield, choosedUsers);
                    events(choosedUsersName);
                }
            })
        },

		selectPostMessageUserCb(dfield, data){
            this.actions.setFormValue(dfield, data, true);
		},
        selectChooseCb(res, data) {
            this.actions.setFormValue(data.dfield, res.value, res.label);
            this.actions.checkValue(data);
        },
        selectMultiChooseCb(res, data) {
            this.actions.setFormValue(data.dfield, res);
            this.actions.checkValue(data);
        },
		//打开密码框弹窗
		addPassword(data) {
			let _this = this;
			let type = data.field_content.type;
			_this.data['addPassWordField'] = data.dfield;
			PMAPI.openDialogByComponent(AddEnrypt, {
				width: 800,
				height: 600,
				title: '修改内容',
				modal: true
			}).then((data) => {
				if (!data.cancel) {
					_this.actions.addEnrypt(data,type);
				}
			});
		},

		//打开快捷添加弹窗
		addItem(data) {
			this.data['quikAddDfield'] = data.dfield;
			let originalOptions;
			if (data.hasOwnProperty("options")) {
				originalOptions = data["options"];
			} else {
				originalOptions = data["group"];
			}
            let formValue = this.actions.createFormValue(this.data.data,false)
            this.actions.createAddItemComponent(originalOptions, data,formValue);
		},

		createAddItemComponent(originalOptions, data,formValue, w, h) {
			let _this = this;
			if (window.innerWidth < 1300) {
				w = 900;
				h = 600;
			}

			PMAPI.openDialogByIframe(`/iframe/addItem/`, {
				width: w || 1400,
				height: h || 810,
				title: `添加新选项`,
				modal: true
			}, {
				fieldId: data.id,
				originalOptions: originalOptions,
                formValue:formValue,
                linkage:this.data.allLinkageData || {}
			}).then((data) => {
				if (data.onlyclose) {
					return;
				}
				_this.actions.addNewItem(data);
			});
		},
		//打开打印页眉设置弹窗 现由工作流负责此功能，以防万一先放着
		async printSetting() {
			let res = await FormService.getPrintSetting()
			// if(res.succ == 1){
			if (res.data && res.data.length && res.data.length != 0) {
				SettingPrint.data['printTitles'] = res['data'];
				SettingPrint.data['key'] = this.data.key;
				SettingPrint.data['myContent'] = res['data'][0]['content'] || '';
				SettingPrint.data['selectNum'] = parseInt(res['data']['index']) || 1;
			}
			PMAPI.openDialogByComponent(SettingPrint, {
				width: 500,
				height: 300,
				title: '自定义页眉',
				modal: true
			})
		},

		//打开子表弹窗
		openSongGrid(data, url) {
			let _this = this;
			// 保存父表数据
			_this.data.can_not_open_form = data.can_not_open_form;
			let type = data["popup"];
			let isView = data["is_view"];
			if (type == 1) {
				this.actions.openType1SongGrid(_this, data, isView, url);
			} else {
				_this.data.sonTableId = data["value"];
				if (isView == '0') {
					_this.actions.setCountData(data.dfield);
				}
			}
			this.actions.saveParentFormValue();
		},

		openType1SongGrid(_this, data, isView, url) {
			_this.data.sonTableId = data["value"];
			if (isView == '0') {
				_this.data.viewMode = 'EditChild';
			} else {
				_this.data.viewMode = 'ViewChild';
			}
			// PMAPI.openDialogByIframe(`/iframe/sourceDataGrid/?tableId=${_this.data.sonTableId}&parentTableId=${data.parent_table_id}&parentRealId=${data.parent_real_id}&parentTempId=${data.temp_id}&rowId=${data.parent_temp_id}&tableType=child&viewMode=${_this.data.viewMode}`, {
			PMAPI.openDialogByIframe(url, {
				width: 1100,
				height: 600,
				title: `子表`,
				modal: true
			}).then(res => {
				if (_this.data.viewMode == 'EditChild') {
					_this.actions.setCountData(data.dfield);
				}
			})
		},

		//打开对应关系弹窗
		openCorrespondence(data) {
			let isView = data["is_view"];
			this.data.sonTableId = data["value"];
			if (isView == '0') {
				this.data.viewMode = 'editFromCorrespondence';
			} else {
				this.data.viewMode = 'viewFromCorrespondence';
			}
			let _this = this;
			let w = 1400, h = 810;
			if (window.innerWidth < 1300) {
				w = 900;
				h = 600;
			}
			PMAPI.openDialogByIframe(`/iframe/sourceDataGrid/?tableId=${data.value}&parentTableId=${CreateFormServer.data.tableId}&parentTempId=${data.temp_id}&parentRealId=${data.parent_real_id}&record_id=${data.recordId}&viewMode=${this.data.viewMode}&showCorrespondenceSelect=true&correspondenceField=${data.dfield}&fromApprove=${data.fromApprove}&isFromForm=true`, {
				width: w,
				height: h,
				title: `对应关系`,
				modal: true
			}).then(res => {
				//关闭对应关系后的回调刷新
				_this.data.childComponent[data.dfield].data.dataGrid.actions.getGridData();
			})
		},

		//打开历史值弹窗
		openHistoryDialog(data) {
			let history = _.defaultsDeep({}, data.history_data);
			let i = 1;
			for (let k in history) {
				history[k]['index'] = i++;
			}
			this.actions.checkHistoryValue(data, history);
			History.show({
				data:{
					history_data:history
				},
			});
		},

		checkHistoryValue(data, history) {
			//处理周期规则值回车符
			if (data.type == 'SettingTextarea' || data.type == 'Readonly') {
				this.actions.checkSettingTextAreaHistoryValue(history);
			}
			//处理文本区回车符
			if (data.type == 'Textarea') {
				this.actions.checkTextAreaHistoryValue(history);
			}
			//处理富文本模板标签
			if (data.type == 'Editor') {
				this.actions.checkEditorHistoryValue(history);
			}
		},

		checkTextAreaHistoryValue(history) {
			for (let key in history) {
				history[key]['new_value'].replace && (history[key]['new_value'] = history[key]['new_value'].replace(/\n/g, ";"));
				history[key]['old_value'].replace && (history[key]['old_value'] = history[key]['old_value'].replace(/\n/g, ";"));
			}
		},

		checkEditorHistoryValue(history) {
			for (let key in history) {
				history[key]['new_value'].replace && (history[key]['new_value'] = history[key]['new_value'].replace(/<.*?>/ig, ""));
				history[key]['old_value'].replace && (history[key]['old_value'] = history[key]['old_value'].replace(/<.*?>/ig, ""));
			}
		},

		checkSettingTextAreaHistoryValue(history) {
			for (let key in history) {
				if (_.isObject(history[key]['new_value']) && history[key]['new_value']['-1']) {
					history[key]['new_value'] = history[key]['new_value']['-1'].replace(/\n/g, ";");
				}
				if (_.isObject(history[key]['old_value'] && history[key]['old_value']['-1'])) {
					history[key]['old_value'] !== undefined ? history[key]['old_value'] = history[key]['old_value']['-1'] : history[key]['old_value'] = history[key]['old_value']['-1'].replace(/\n/g, ";");
				}
			}
		},

		beforeCreateFormControl(data, key) {
			if (this.data.isEdit == 0 && this.data.isCalendar === '1') {
				data[key].is_view = 1;
			}
			let single = this.el.find('div[data-dfield=' + data[key].dfield + ']');
			let type = single.data('type');
			if (single.parent().find('div').length > 2) {
				single.css('display', 'inline-block');
			}
			if (data[key].required) {
				let val=data[key].value;
				data[key]['requiredClass'] = val === '' || val.length === 0 || JSON.stringify(val) === "{}" ? 'required' + this.data.fontsize : 'required2' + this.data.fontsize;
				if (type == 'Songrid') {
					data[key]['requiredClass'] = data[key].total == 0 ? 'required' + this.data.fontsize : 'required2' + this.data.fontsize;
				}
				if(type == 'Buildin'){
					if(data[key].options.length && data[key].options[0].label==''){
                        data[key]['requiredClass']='required'+this.data.fontsize
					}
				}
			}
			if (single.data('width')) {
				data[key]['width'] = single.data('width') + 'px';
			} else {

				data[key]['width'] = '240px';
			}
			//数据填充后，根据修改条件对不同框进行只读操作
			let _this = this;
			setTimeout(() => {
				_this.actions.reviseCondition(data[key], data[key].value);
			}, 0);
			return {single, type};
		},

		renderAndSaveFormControl(formComponent, data, key, single) {
			try {
				formComponent.render(single);
			} catch (e) {
				console.log(e);
			}
			if (!this.data.isWX) {
				this.data.childComponent[data[key].dfield] = formComponent;
			}
		},

		createInputControl(data, key, single, actions) {
			this.actions.renderAndSaveFormControl(new Input({data: data[key], events: actions}), data, key, single);
		},
		createWXInputControl(data, key, single) {
			this.actions.renderAndSaveFormControl(this.data.newControl = new InputWX({
				data: Object.assign(data[key], {submit: data[key].is_view ? false : true}),
				events: this.data.WXactions
			}), data, key, single);
		},

		createCorrespondenceControl(data, key, single, actions) {
			data[key]['temp_id'] = data['temp_id']['value'];
			data[key]['correspondenceHasValue'] = false;
			data[key]['fromApprove'] = this.data.fromApprove;
			let correspondence = new Correspondence({data: data[key], events: actions});
			this.actions.renderAndSaveFormControl(correspondence, data, key, single);
		},
		createWXCorrespondenceControl(data, key, single) {
			data[key]['temp_id'] = data['temp_id']['value'];
			data[key]['correspondenceHasValue'] = false;
			this.data.newControl = new CorrespondenceWX({
				data: Object.assign(data[key], {submit: data[key].is_view ? false : true}),
				events: this.data.WXactions
			});
			this.actions.renderAndSaveFormControl(this.data.newControl, data, key, single);
		},

		createSongridControl(data, key, single, actions) {
			let popupType = single.data('popuptype') || 0;
			data[key]['temp_id'] = data['temp_id']['value'];
			data[key]['popup'] = popupType;
            data[key]['index']=this.data.index;
			if(this.data.isCreate || this.data.record_info.record_status === 0){
				data[key]['isInprocessFilter']=1;
			}
			//获取表单数据（子表导入用）
			let formData = {};
			for (let k in data) {
				formData[k] = data[k].value || '';
			}
			let songrid = new Songrid({
				data: Object.assign(data[key], {
					fromApprove: this.data.fromApprove,
					popupType: popupType,
					formData: JSON.stringify(formData)
				}), events: actions
			});
			this.actions.renderAndSaveFormControl(songrid, data, key, single);
		},
		createWXSongridControl(data, key, single) {
			let popupType = single.data('popuptype') || 0;
			data[key]['temp_id'] = data['temp_id']['value'];
			data[key]['popup'] = popupType;
			//获取表单数据（子表导入用）
			let formData = {};
			for (let k in data) {
				formData[k] = data[k].value || '';
			}
			this.data.newControl = new SongridWX({
				data: Object.assign(data[key], {
					submit: data[key].is_view ? false : true,
					fromApprove: this.data.fromApprove,
					popupType: popupType,
					formData: JSON.stringify(formData)
				}), events: this.data.WXactions
			});
			try {
				this.actions.renderAndSaveFormControl(this.data.newControl, data, key, single);
			} catch (err) {
				alert(err);
			}
		},

		createRadioControl(data, key, single, actions) {
			this.actions.setRadioCheck(data[key]);
			let radio = new Radio({data: data[key], events: actions});
			this.actions.renderAndSaveFormControl(radio, data, key, single);
		},

		createWXRadioControl(data, key, single) {
			this.actions.setRadioCheck(data[key]);
			this.data.newControl = new RadioWX({
				data: Object.assign(data[key], {submit: data[key].is_view ? false : true}),
				events: this.data.WXactions
			});
			this.actions.renderAndSaveFormControl(this.data.newControl, data, key, single);
		},

		createTextareaControl(data, key, single, actions) {
			let textArea = new TextArea({data: data[key], events: actions});
			this.actions.renderAndSaveFormControl(textArea, data, key, single);
		},
		createWXTextareaControl(data, key, single) {
			this.actions.renderAndSaveFormControl(this.data.newControl = new TextAreaWX({
				data: Object.assign(data[key], {submit: data[key].is_view ? false : true}),
				events: this.data.WXactions
			}), data, key, single);
		},

		createReadonlyControl(data, key, single, actions) {
			if (this.data.tempId) {
				data[key].canNotOpen = false;
			}
			if (data[key].real_type == 9 || data[key].real_type == 23 || data[key].real_type == 33) {
				data[key]['read_only'] = 1;
                data[key]['temp_id'] = this.data.data.temp_id['value'];
                data[key]['real_id'] = this.data.realId;
                data[key]['table_id'] = this.data.table_id;
				let attachmentControl = new AttachmentControl({data: data[key], events: actions});
				this.actions.renderAndSaveFormControl(attachmentControl, data, key, single);
				return;
			}
			let readonly = new Readonly({data: data[key], events: actions});
			this.actions.renderAndSaveFormControl(readonly, data, key, single);
		},

		createWXReadonlyControl(data, key, single) {
			if (this.data.tempId) {
				data[key].canNotOpen = false;
			}
			if (data[key].real_type == 9 || data[key].real_type == 23 || data[key].real_type == 33) {
				data[key]['read_only'] = 1;
				this.data.newControl = new AttachmentControlWX({data: data[key], events: this.data.WXactions});
				this.actions.renderAndSaveFormControl(this.data.newControl, data, key, single);
				return;
			}
			this.data.newControl = new Readonly({data: data[key], events: this.data.WXactions});
			this.actions.renderAndSaveFormControl(this.data.newControl, data, key, single);
		},

		createEnctyptInputControl(data, key, single, actions) {
			let password = new Password({data: data[key], events: actions});
			this.actions.renderAndSaveFormControl(password, data, key, single);
		},

		createWXEnctyptInputControl(data, key, single) {
			this.actions.renderAndSaveFormControl(this.data.newControl = new PasswordWX({
				data: Object.assign(data[key], {submit: data[key].is_view ? false : true}),
				events: this.data.WXactions
			}), data, key, single);
		},

		createHiddenControl(data, key, single, actions) {
			let hidden = new Hidden({data: data[key]});
			this.actions.renderAndSaveFormControl(hidden, data, key, single);
		},

		createWXHiddenControl(data, key, single) {
			this.data.newControl = new HiddenWX({data: data[key]});
			this.actions.renderAndSaveFormControl(this.data.newControl, data, key, single);
		},

		createSelectControl(data, key, single, actions) {
			let selectControl = new SelectControl({data: data[key], events: actions});
			this.actions.renderAndSaveFormControl(selectControl, data, key, single);
		},

		createWXSelectControl(data, key, single) {
			this.data.newControl = new SelectControlWX({
				data: Object.assign(data[key], {submit: data[key].is_view ? false : true}),
				events: this.data.WXactions
			});
			this.actions.renderAndSaveFormControl(this.data.newControl, data, key, single);
		},

		createYearControl(data, key, single, actions) {
			let yearControl = new YearControl({data: data[key], events: actions});
			this.actions.renderAndSaveFormControl(yearControl, data, key, single);
		},

		createWXYearControl(data, key, single) {
			this.data.newControl = new YearControlWX({
				data: Object.assign(data[key], {submit: data[key].is_view ? false : true}),
				events: this.data.WXactions
			});
			this.actions.renderAndSaveFormControl(this.data.newControl, data, key, single);
		},

		createYearmonthtimeControl(data, key, single, actions) {
			let yearMonthControl = new YearMonthControl({data: data[key], events: actions});
			this.actions.renderAndSaveFormControl(yearMonthControl, data, key, single);
		},

		createWXYearmonthtimeControl(data, key, single) {
			this.data.newControl = new YearMonthControlWX({
				data: Object.assign(data[key], {submit: data[key].is_view ? false : true}),
				events: this.data.WXactions
			});
			this.actions.renderAndSaveFormControl(this.data.newControl, data, key, single);
		},

		async createBuildinControl(data, key, single, actions) {
			// if (data[key].options == 'other_place') {
			// 	if (!(this.data.buildin_options && this.data.buildin_options[data[key].id])) {
			// 		let res = await FormService.getFormStaticBuildinData(this.actions.createPostJson());
			// 		this.data.oldData[key].options = data[key].options = (res.buildin_options && res.buildin_options[data[key].id]) ? res.buildin_options[data[key].id] : [{
			// 			value: '',
			// 			label: ''
			// 		}];
			// 	} else {
			// 		this.data.oldData[key].options = data[key].options = this.data.buildin_options[data[key].id];
			// 	}
			// }
			if(data[key].options.length && data[key].options[0].value){
				data[key].selectLabel=data[key].options[0].label
			}
			let buildInControl = new BuildInControl({data: data[key], events: actions});
			this.actions.renderAndSaveFormControl(buildInControl, data, key, single);
		},

		async createMultiLinkageControl(data, key, single, actions) {
			// if (data[key].dataList == 'other_place') {
			// 	if (!(this.data.buildin_options && this.data.buildin_options[data[key].id])) {
			// 		let res = await FormService.getFormStaticBuildinData(this.actions.createPostJson());
			// 		this.data.oldData[key].dataList = data[key].dataList = res.buildin_options && res.buildin_options[data[key].id] ? res.buildin_options[data[key].id] : {' ': ['请选择', '请选择']};
			// 	} else {
			// 		this.data.oldData[key].dataList = data[key].dataList = this.data.buildin_options[data[key].id];
			// 	}
			// }
			let multiLinkageControl = new MultiLinkageControl({data: data[key], events: actions});
			this.actions.renderAndSaveFormControl(multiLinkageControl, data, key, single);
		},

		async createMultiSelectControl(data, key, single, actions) {
			// if (data[key].options == 'other_place') {
			// 	if (!(this.data.buildin_options && this.data.buildin_options[data[key].id])) {
			// 		let res = await FormService.getFormStaticBuildinData(this.actions.createPostJson());
			// 		this.data.oldData[key].options = data[key].options = (res.buildin_options && res.buildin_options[data[key].id]) ? res.buildin_options[data[key].id] : [{
			// 			value: '',
			// 			label: ''
			// 		}];
			// 	} else {
			// 		this.data.oldData[key].options = data[key].options = this.data.buildin_options[data[key].id];
			// 	}
			// }
			if (single.data('childData')) {
				data[key].childData = single.data('childData');
			}
			if (single.data('selectType')) {
				data[key].childData = single.data('selectType');
			}
			data[key].is_special = data[key].field_content['special_multi_choice'] == 1 ? true : false;
			let multiSelectControl = new MultiSelectControl({data: data[key], events: actions});
			this.actions.renderAndSaveFormControl(multiSelectControl, data, key, single);
		},

		async createWXBuildinControl(data, key, single) {
			if (data[key].options == 'other_place') {
				if (!(this.data.buildin_options && this.data.buildin_options[data[key].id])) {
					let res = await FormService.getFormStaticBuildinData(this.actions.createPostJson());
					this.data.oldData[key].options = data[key].options = (res.buildin_options && res.buildin_options[data[key].id]) ? res.buildin_options[data[key].id] : [{
						value: '',
						label: ''
					}];
				} else {
					this.data.oldData[key].options = data[key].options = this.data.buildin_options[data[key].id];
				}
			}
			this.data.newControl = new BuildInControlWX({
				data: Object.assign(data[key], {submit: data[key].is_view ? false : true}),
				events: this.data.WXactions
			});
			this.actions.renderAndSaveFormControl(this.data.newControl, data, key, single);
		},
		async createWXMultiLinkageControl(data, key, single) {
			if (data[key].dataList == 'other_place') {
				if (!(this.data.buildin_options && this.data.buildin_options[data[key].id])) {
					let res = await FormService.getFormStaticBuildinData(this.actions.createPostJson());
					this.data.oldData[key].dataList = data[key].dataList = res.buildin_options && res.buildin_options[data[key].id] ? res.buildin_options[data[key].id] : {' ': ['请选择', '请选择']};
				} else {
					this.data.oldData[key].dataList = data[key].dataList = this.data.buildin_options[data[key].id];
				}
			}
			this.data.newControl = new MultiLinkageControlWX({
				data: Object.assign(data[key], {submit: data[key].is_view ? false : true}),
				events: this.data.WXactions
			});
			this.actions.renderAndSaveFormControl(this.data.newControl, data, key, single);
		},

		async createWXMultiSelectControl(data, key, single) {
			if (data[key].options == 'other_place') {
				if (!(this.data.buildin_options && this.data.buildin_options[data[key].id])) {
					let res = await FormService.getFormStaticBuildinData(this.actions.createPostJson());
					this.data.oldData[key].options = data[key].options = (res.buildin_options && res.buildin_options[data[key].id]) ? res.buildin_options[data[key].id] : [{
						value: '',
						label: ''
					}];
				} else {
					this.data.oldData[key].options = data[key].options = this.data.buildin_options[data[key].id];
				}
			}
			if (single.data('childData')) {
				data[key].childData = single.data('childData');
			}
			if (single.data('selectType')) {
				data[key].childData = single.data('selectType');
			}
			data[key].is_special = data[key].field_content['special_multi_choice'] == 1 ? true : false;
			this.data.newControl = new MultiSelectControlWX({
				data: Object.assign(data[key], {submit: data[key].is_view ? false : true}),
				events: this.data.WXactions
			});
			this.actions.renderAndSaveFormControl(this.data.newControl, data, key, single);
		},

		createEditorControl(data, key, single, actions) {
			let editorControl = new EditorControl({data: data[key], events: actions});
			this.actions.renderAndSaveFormControl(editorControl, data, key, single);
		},

		createWXEditorControl(data, key, single) {
			this.data.newControl = new EditorControlWX({
				data: Object.assign(data[key], {submit: data[key].is_view ? false : true}),
				events: this.data.WXactions
			});
			this.actions.renderAndSaveFormControl(this.data.newControl, data, key, single);
		},

		createSettingTextareaControl(data, key, single, actions) {
			let settingTextareaControl = new SettingTextareaControl({data: data[key], events: actions});
			this.actions.renderAndSaveFormControl(settingTextareaControl, data, key, single);
		},

		createPictureControl(data, key, single, actions) {
			data[key]['form_id'] = this.data.form_id;
            data[key]['temp_id'] = this.data.data.temp_id['value'];
            data[key]['real_id'] = this.data.realId;
            data[key]['table_id'] = this.data.table_id;
			let attachmentControl = new AttachmentControl({data: data[key], events: actions});
			this.actions.renderAndSaveFormControl(attachmentControl, data, key, single);
		},

		createWXPictureControl(data, key, single) {
			data[key]['form_id'] = this.data.form_id;
			this.data.newControl = new AttachmentControlWX({
				data: Object.assign(data[key], {submit: data[key].is_view ? false : true}),
				events: this.data.WXactions
			});
			this.actions.renderAndSaveFormControl(this.data.newControl, data, key, single);
		},

		createTimeControl(data, key, single, actions) {
			let timeControl = new TimeControl({data: data[key], events: actions});
			this.actions.renderAndSaveFormControl(timeControl, data, key, single);
		},

		createWXTimeControl(data, key, single) {
			this.data.newControl = new TimeControlWX({
				data: Object.assign(data[key], {submit: data[key].is_view ? false : true}),
				events: this.data.WXactions
			});
			this.actions.renderAndSaveFormControl(this.data.newControl, data, key, single);
		},

		createDateControl(data, key, single, actions) {
			let dateControl = new DateControl({data: data[key], events: actions});
			this.actions.renderAndSaveFormControl(dateControl, data, key, single);
		},

		createWXDateControl(data, key, single) {
			this.data.newControl = new DateControlWX({
				data: Object.assign(data[key], {submit: data[key].is_view ? false : true}),
				events: this.data.WXactions
			});
			this.actions.renderAndSaveFormControl(this.data.newControl, data, key, single);
		},

		createDatetimeControl(data, key, single, actions) {
			let dateTimeControl = new DateTimeControl({data: data[key], events: actions});
			this.actions.renderAndSaveFormControl(dateTimeControl, data, key, single);
		},

		createWXDatetimeControl(data, key, single) {
			this.data.newControl = new DateTimeControlWX({
				data: Object.assign(data[key], {submit: data[key].is_view ? false : true}),
				events: this.data.WXactions
			});
			this.actions.renderAndSaveFormControl(this.data.newControl, data, key, single);
		},

		createeditControlControl(data, key, single, actions) {
			if (this.data.btnType == 'new') {
				data[key]['isAdd'] = true;
			} else {
				data[key]['isAdd'] = false;
			}
			data[key]['real_id'] = data['real_id']['value'];
			data[key]['table_id'] = data['table_id']['value'];
			data[key]['temp_id'] = data['temp_id']['value'];
			data[key]['iframe_key'] = window.config.key;
			let contractControl = new ContractControl({data: data[key], events: actions});
			this.actions.renderAndSaveFormControl(contractControl, data, key, single);
		},
		async createPostMessageGetUsersControl(data, key, single, actions){
			console.log('createPostMessageGetUsersControl', data);
			let postMessage = new PostMessageGetUser({data: data[key], events: actions});
            this.actions.renderAndSaveFormControl(postMessage, data, key, single);
		},
		changeWXValue(data) {
			this.actions.destoryControl();
			this.actions.setWXvalue(data.dfield, data);
			this.actions.checkValue(data);
		},

		destoryControl() {
			this.data.newControl.destroySelf();
			this.el.find('.wxControl-wrap').hide();
			this.el.closest('.weui-tab').find('.weui-tabbar').css('display', 'flex');
		},

		async showWXControl(data, event) {
			let dfield = $(event.target).data('dfield') || $(event.target).find('div').data('dfield');
			let type = data[dfield].type;
			if (!dfield || !~this.data.canRenderControl.indexOf(type)) {
				return;
			}
			let single = this.el.find('.wxControl-wrap').append($('<div></div>')).find('div');
			if (data[dfield].unvisible || data[dfield].be_control_condition) {
				return;
			}
			switch (type) {
				case 'Correspondence':
					this.actions.createWXCorrespondenceControl(data, dfield, single);
					break;
				case 'Songrid':
					this.actions.createWXSongridControl(data, dfield, single);
					break;
				case 'Radio':
					this.actions.createWXRadioControl(data, dfield, single);
					break;
				case 'Input':
					this.actions.createWXInputControl(data, dfield, single);
					break;
				case 'Textarea':
					this.actions.createWXTextareaControl(data, dfield, single);
					break;
				case 'EnctyptInput':
					this.actions.createWXEnctyptInputControl(data, dfield, single);
					break;
				case 'Select':
					this.actions.createWXSelectControl(data, dfield, single);
					break;
				case 'Year':
					this.actions.createWXYearControl(data, dfield, single);
					break;
				case 'Yearmonthtime':
					this.actions.createWXYearmonthtimeControl(data, dfield, single);
					break;
				case 'Buildin':
					await this.actions.createWXBuildinControl(data, dfield, single);
					break;
				case 'MultiLinkage':
					await this.actions.createWXMultiLinkageControl(data, dfield, single);
					break;
				case 'MultiSelect':
					this.actions.createWXMultiSelectControl(data, dfield, single)
					break;
				case 'Editor':
					this.actions.createWXEditorControl(data, dfield, single);
					break;
				case 'Attachment':
				case 'Picture':
					this.actions.createWXPictureControl(data, dfield, single)
					break;
				case 'Time':
					this.actions.createWXTimeControl(data, dfield, single);
					break;
				case 'Date':
					this.actions.createWXDateControl(data, dfield, single);
					break;
				case 'Datetime':
					this.actions.createWXDatetimeControl(data, dfield, single)
					break;
				default:
					break;
			}
			this.el.find('.wxControl-wrap').show();
		},

		createWXControlValue(key, data, type) {
			let value = '';
			if (['Radio', 'Select', 'Buildin'].indexOf(type) != -1) {
				value = this.actions.getTextByOptionID(key, data.value)
			} else if (type == 'Attachment' || type == 'Picture') {
				value = type == 'Picture' ? '查看图片' : '查看附件';
			} else if (type == 'Correspondence') {
				value = '查看对应关系';
			} else if (type == 'Songrid') {
				value = '查看子表';
			} else if (type == 'MultiLinkage') {
				if (data.value == '') {
					value = '';
				} else {
					value = data['dataList'][data.value];
				}
			} else if (type == 'EnctyptInput') {
				value = data.value ? '***' : '';
			} else if (type == 'SettingTextarea' || type == 'editControl') {
				value = '移动端不支持此类型'
			} else if (type == 'MultiSelect') {
				for (let v of data.value) {
					for (let opt of data.options) {
						if (opt.value == v) {
							value += opt.label + ',';
						}
					}
				}
				if (value.length > 0) {
					value = value.substring(0, value.length - 1);
				}
			}
			else {
				value = data.value;
			}
			if (data.unvisible) {
				value = '<span style="color:#ccc">权限受限</span>'
			}
			if (data.be_control_condition) {
				value = '<span style="color:#ccc">被修改条件限制</span>'
			}
			return value;
		},

		//创建微信表单
		createWXFormControl() {
			let data = this.data.data;
			this.data.canRenderControl = ['Correspondence', 'Songrid', 'Radio', 'Input', 'Textarea', 'EnctyptInput', 'Select', 'Year', 'Yearmonthtime', 'Buildin', 'MultiLinkage', 'MultiSelect', 'Editor', 'Attachment', 'Picture', 'Time', 'Datetime', 'Date'];
			this.setData('oldData', _.defaultsDeep({}, data));
			this.el.find('td').css('white-space', 'pre-wrap');
			for (let key in data) {
				this.actions.reviseCondition(data[key], data[key].value);
				this.actions.setAccuracy(data[key]);
				let obj = data[key];
				let single = this.el.find('div[data-dfield=' + obj.dfield + ']');
				let type = single.data('type');
				if (type == 'Hidden') {
					$(single).hide();
					continue;
				}
				let span = '';
				if (obj.required && (obj.value === '' || obj.value.length === 0 || JSON.stringify(obj.value) === "{}")) {
					span = '<span class="required"></span>'
				}
				let value = span + this.actions.createWXControlValue(key, obj, type);
				try {
					single.get(0).innerHTML = value;
				} catch (err) {

				}
			}
			this.el.append($('<div class="wxControl-wrap" style="display: none;width: 100%;height:100%;position: fixed;top: 0;left: 0;background: rgba(228,228,228,.8);z-index:101"></div>'));
			$('html').css({'overflow': 'hidden', 'height': '100%', 'width': '100%'});
			$('body').css({'overflow': 'hidden', 'height': '100%', 'width': '100%'});
			this.el.find('table').bind('click', (event) => {
				event.stopPropagation();
				this.actions.showWXControl(this.data.data, event);
			});
		},
		//设置数字精度
		setAccuracy: function (data) {
			if (data["accuracy"]) {
				//如果是浮点数
				//数据处理（如果数据已经限定了小数位数，如果不满足，四舍五入让其满足）
                let accuracy = data["accuracy"];
                let v = Number(data.value).toFixed(accuracy);
				if (!Object.is(Number(data.value), NaN)) {
					data.value = v;
				}
				else if (data.value.indexOf(",")&& !Object.is(Number(data.value.substr(0).replace(/,/g,'')), NaN)
                ) {
					//判断是否有小数点
                    if(data.value.lastIndexOf('.')==-1){
                        data.value=(data.value+'.')
                    }
					let len=data.value.lastIndexOf('.')+Number(accuracy)+1;
					data.value= data.value.length<len? data.value.padEnd(len,'0'):data.value;
                }
            }
		},
		//动态创建组件
		async createFormControl() {
			this.setData('childComponent', {});
			let data = this.data.data;
			let actions = this.actions.createActions();
			for (let key in data) {
				if(data[key].value===null){
					data[key].value='';
				}
				this.actions.setAccuracy(data[key]);
				let {single, type} = this.actions.beforeCreateFormControl(data, key);
				this.data.data[key].fontsize = this.data.fontsize;
				//在这里根据type创建各自的控件
				switch (type) {
					case 'Correspondence':
						this.actions.createCorrespondenceControl(data, key, single, actions);
						break;
					case 'Songrid':
						this.actions.createSongridControl(data, key, single, actions);
						break;
					case 'Radio':
						this.actions.createRadioControl(data, key, single, actions);
						break;
					case 'Input':
						this.actions.createInputControl(data, key, single, actions);
						break;
					case 'Textarea':
						this.actions.createTextareaControl(data, key, single, actions);
						break;
					case 'Readonly':
						this.actions.createReadonlyControl(data, key, single, actions);
						break;
					case 'EnctyptInput':
						this.actions.createEnctyptInputControl(data, key, single, actions);
						break;
					case 'Hidden':
						this.actions.createHiddenControl(data, key, single, actions);
						break;
					case 'Select':
						this.actions.createSelectControl(data, key, single, actions);
						break;
					case 'Year':
						this.actions.createYearControl(data, key, single, actions);
						break;
					case 'Yearmonthtime':
						this.actions.createYearmonthtimeControl(data, key, single, actions);
						break;
					case 'Buildin':
						await this.actions.createBuildinControl(data, key, single, actions);
						break;
					case 'MultiLinkage':
						await this.actions.createMultiLinkageControl(data, key, single, actions);
						break;
					case 'MultiSelect':
						this.actions.createMultiSelectControl(data, key, single, actions)
						break;
					case 'Editor':
						this.actions.createEditorControl(data, key, single, actions);
						break;
					case 'SettingTextarea':
						this.actions.createSettingTextareaControl(data, key, single, actions)
						break;
					case 'Attachment':
					case 'Picture':
						this.actions.createPictureControl(data, key, single, actions)
						break;
					case 'Time':
						this.actions.createTimeControl(data, key, single, actions);
						break;
					case 'Date':
						this.actions.createDateControl(data, key, single, actions);
						break;
					case 'Datetime':
						this.actions.createDatetimeControl(data, key, single, actions)
						break;
					case 'editControl':
						this.actions.createeditControlControl(data, key, single, actions)
						break;
					case 'PostMessageGetUsers':
						await this.actions.createPostMessageGetUsersControl(data, key, single, actions)
						break;
				}
			}
            this.setData('oldData', _.defaultsDeep({}, data));
		},
		//解决空的多级内置表单入库后查看模式下该字段输入框缺失bug
		HandleViewMultiLinkage(){
            for (let key in this.data.data){
                let data=this.data.data;
				if (!this.data.data.hasOwnProperty(key)) continue;
                if (data[key].type==='MultiLinkage'&&_.isEmpty(data[key].value)&&this.data.isView!=0) {
                    this.data.isViewEmptyMultiLinkage=true;
                }
                else continue;
            }
		},
		async getOptions() {
			this.actions.HandleViewMultiLinkage();
            if(this.data.isView!=0&&!this.data.isViewEmptyMultiLinkage){
				return;
			}
			let res = await FormService.getFormStaticBuildinData(this.actions.createPostJson());
            if (res.success) {
				for (let key in res.buildin_options) {
					let options = res.buildin_options[key];
					if (!this.data.data[key] || this.data.data[key].isFromParent) {
						continue;
					}
					let child = this.data.childComponent[key];
					if (this.data.data[key].show_label != '1') {
                        if (this.data.data[key].type != 'MultiLinkage') {
                            this.data.data[key].options = options;
                            this.data.oldData[key].options=options;
                            child && (child.data.options = options);
                        } else {
                            this.data.data[key].dataList = options;
                            this.data.oldData[key].dataList=options;
                            child && (child.data.dataList = options);
                        }
					}
					// 目前先在这里过滤 消息推送表 申请发送人员列表字段(多选内置) 重新渲染导致重复发送获取部门数据的问题
                    if (child && (child.data.id && child.data.id!='3539_jdCwuJCyXvuGCoHGECNQGm')) {
                        child.reload();
                    }
				}
				if (this.data.table_name == '人员信息') {
					this.actions.deferSetMainDepOptions();
				}
                Mediator.publish('form:create'+this.data.tableId, 'success');
			} else {
				alert(res.error);
			}
            this.actions.initMiniForm();
		},

		//改变人员信息表主岗选项
		changeMainDepart(isClick, _this) {
			let arr = [{value: '', label: '请选择'}];
			//判断是否需要将主岗部门置为请选择
			if (isClick) {
				let arr_1 = [];
				for (let i = 1; i < _this.department["options"].length; i++) {
					arr_1.push(_this.department["options"][i]["value"]);
				}
				if (arr_1.length != _this.value.length) {
					this.actions.setFormValue(_this.form_department, '');
				}
			}
			//改变主岗部门option
			for (let i = 0; i < _this.value.length; i++) {
				for (let j in _this.main_depart) {
					if (_this.main_depart[j]["value"] === _this.value[i]) {
						arr.push(_this.main_depart[j]);
					}
				}
			}
			this.data.data[_this.department.dfield]["options"] = arr;
			this.data.childComponent[_this.department.dfield].data["options"] = arr;
			this.data.childComponent[_this.department.dfield].reload();
		},
		//给外部提供cacheNew cacheOld
		getCacheData() {
			let formValue = this.actions.createFormValue(this.data.data, true);
			if (formValue.error) {
				return formValue;
			}
			let data = this.actions.handleFormData(formValue);
			let formDataOld = this.data.oldData;
			let obj_new = this.actions.createCacheData(formDataOld, data, true, this);
			let obj_old = this.actions.createCacheData(formDataOld, data, false, this);
			return {
				obj_new,
				obj_old
			}
		},
		setVoteValue() {
			if (this.data.vote_key && this.data.vote_value) {
				this.actions.setFormValue(this.data.vote_key, this.data.data[this.data.vote_key].value, false);
			}
		},
		saveVoteValue(res) {
			let value = res.value;
			this.data.submitKey = res.submitKey;
			if (value) {
				for (let key in this.data.data) {
					if (this.data.data[key].id == value) {
						let val
						if (this.data.vote_value) {
							if (this.data.vote_value == value) {
								break;
							} else {
								this.data.data[this.data.vote_key].value = this.data.data[this.data.vote_key].value - 1;
								this.data.data[key].value = this.data.data[key].value + 1;
								this.data.vote_value = value;
								this.data.vote_key = key;
								break;
							}
						} else {
							this.data.data[key].value = this.data.data[key].value + 1;
							this.data.vote_key = key;
							this.data.vote_value = value;
							this.data.vote_key = key;
							break;
						}
					}
				}
				setTimeout(() => {
					Mediator.publish('form:voteAllready', {vote_key:this.data.vote_key})
				}, 0);
			}
		},
		saveParentRelation() {
			//存父子表关系
			if (!window.top.frontendRelation) {
				window.top.frontendRelation = {};
			}
			if (!window.top.frontendParentNewData) {
				window.top.frontendParentNewData = {};
			}
			if (!window.top.isSonGridDataNeedParentTepmId) {
				window.top.isSonGridDataNeedParentTepmId = '';
			}
			if (!window.top.idsInChildTableToParent) {
				window.top.idsInChildTableToParent = {};
			}
			if (!window.top.frontendParentFormValue) {
				window.top.frontendParentFormValue = {};
			}
            window.top.frontendParentFormValue[this.data.tableId]={};
			window.top.frontendRelation[this.data.tableId] = this.data["frontend_cal_parent_2_child"];
			//存父表的newData
			window.top.frontendParentNewData[this.data.tableId] = _.defaultsDeep({}, this.data.data);
			window.top.isSonGridDataNeedParentTepmId = this.data.data['temp_id'] && this.data.data['temp_id']['value'] ? this.data.data['temp_id']['value'] : '';
		},
		formStyle() {
			if (this.data.userInfoDfields) {
				for (let dfiled of this.data.userInfoDfields) {
					this.el.find(`[data-dfield=${dfiled}]`).parent().parent().remove();
				}
			}
			//默认表单样式
			if (this.el.find('table').hasClass('form-version-table-user') || this.el.find('table').hasClass('form-version-table-department')) {
				this.el.find('table').parents('.form-print-position').css("margin-bottom", "40px");
			}
			this.el.find("#form-paging-tabs-control  .paging-tabs-tabform").on('click', function () {
				$(this).css('background', '#ffffff').siblings().css('background', '#F2F2F2');
			})
		},
		//延迟设置主岗部门options
		deferSetMainDepOptions(){
			let {dep,whole}=CreateForm.deferSetMainDepOptions(this.data);
			this.data.childComponent[dep].data.options=JSON.parse(JSON.stringify(this.data.data[dep].options));
			this.data.childComponent[whole].data=_.defaultsDeep(this.data.childComponent[whole].data,this.data.data[whole]);
			this.data.childComponent[dep].reload();
		},
		async initForm() {
			this.actions.saveParentRelation();
			this.data.isInit = true;
			if (this.data.isWX) {
				this.data.WXactions = {
					changeWXValue: this.actions.changeWXValue,
					destoryControl: this.actions.destoryControl,
					addPassword: this.actions.addPassword,
					userSysOptions: this.actions.changeMainDepart
				}
				await this.actions.createWXFormControl();
			} else {
				await this.actions.createFormControl();
			}
			if (this.data.is_view == 1) {
				this.actions.checkCustomTable();
			}
			// this.actions.triggerControl();
			this.actions.setDataFromParent();
			if(this.data.isView==0){
                await this.actions.firstGetData();
			}
			this.actions.changeOptions();
			if(this.data.correspondence_status == '2'){
			    this.data.btnType = 'onlyView';
			    MSG.alert('数据正在审批，无法操作。');
            }
			if (this.data.btnType != 'none' || (this.data.isWX && this.data.is_view == '0' && this.data.from_workflow)) {
				this.actions.addBtn();
			}
			if (this.data.isWX) {
				this.el.closest('.workflow-wrapper').css('overflow', 'scroll');
			}
			this.actions.getOptions();
			this.actions.saveParentFormValue();
			this.actions.checkRequiredCondition();
			// this.actions.formStyle();

		},
		initMiniForm() {
            if (window.top.miniFormVal && !this.data.data['real_id']['value']) {
                let miniFormVal = window.top.miniFormVal[this.data.data['table_id']['value']]
                for (let k in miniFormVal) {
                    let val = miniFormVal[k];
                    this.actions.setFormValue(k, val)
                }
            }
		},
		saveParentFormValue() {
			let formValue = this.actions.createFormValue(this.data.data);
			for (let dfield in formValue) {
				let data = this.data.data[dfield];
				if (data.type == 'Buildin' || data.type == 'Select' || data.type == 'Radio') {
					formValue[dfield] = {value: formValue[dfield]};
					formValue[dfield].label = this.actions.getTextByOptionID(data.dfield, formValue[dfield].value);
				}
				if (data.type == 'MultiSelect') {
					formValue[dfield] = {value: formValue[dfield]};
					formValue[dfield].label = this.actions.saveMultiSelectLabel(dfield, formValue[dfield].value);
				}
				if (data.type == 'MultiLinkage') {
					formValue[dfield] = {value: formValue[dfield]};
					formValue[dfield].label = this.actions.saveMultiLinkageLabel(dfield, formValue[dfield].value);
				}
			}
			window.top.frontendParentFormValue[this.data.tableId] = formValue;
		},
		saveMultiLinkageLabel(dfield, values) {
			if (Array.isArray(values) || values == '') {
				return '';
			}
			let options = this.data.data[dfield].dataList || [];
			let string = '';
			for (let item in options[values]) {
				string = `${string}_${options[values][item]}`
			}
			string = string.substring(1);
			return string;
		},
		saveMultiSelectLabel(dfield, values) {
			if (!Array.isArray(values)) {
				return '';
			}
			let options = this.data.data[dfield].options || [];
			let string = '';
			for (let obj of options) {
				if (~values.indexOf(obj.value)) {
					string += obj.label + ',';
				}
			}
			return string.slice(0, string.length - 1);
		},
		//生成表单分页
		createFormTabs() {
			this.el.find("#form-paging-tabs-control").tabs();
		}
	},
    afterRender() {
        this.data.changeBtnClick=false;
		this.data.fontsize = window.config.fontsize == 12 ? '' : window.config.fontsize;
		this.actions.initForm();
        //判断是否打开子表的新增
		if (this.data.isFromForm) {
            parent.document.querySelector(".ui-dialog").style.zIndex=10002;
		}
		//生成表单分页
		this.actions.createFormTabs();
        this.actions.formStyle();
	},

	firstAfterRender() {
		Mediator.subscribe('workflow:voteconfirm', (res) => {
			this.actions.saveVoteValue(res);
		})
		Mediator.subscribe('workflow:voteconfirmAllready', (res) => {
			if (res) {
				if (this.data.vote_key && this.data.data[this.data.vote_key] && this.data.data[this.data.vote_key].value) {
					this.data.data[this.data.vote_key].value = this.data.data[this.data.vote_key].value - 1;
				}
				this.actions.setVoteValue()
			}
		})
		Mediator.on('contract:change:btn', (res) => {
			if (this.data.btnType == 'view') {
				this.actions.changeToEdit();
				// this.data.btnType = 'edit'
				// this.actions.addBtn();
			}
		})
		Mediator.subscribe('attachment:upLoading', (res) => {
			if (res.finished === null) {
				if (this.data.attachmentState.hasOwnProperty(res.file_name))
					delete this.data.attachmentState[res.file_name]
			} else {
				this.data.attachmentState[res.file_name] = res.finished
			}
		})
        //刷新联动数据
        Mediator.subscribe('remind-form:add-linkage-success', (data) => {
            this.data.childComponent[data.dfield].el.find('.add-linkage').css('visibility','hidden');
            this.data.childComponent[data.dfield].data.is_linkage = false;
            if(data['linkage'] && Object.keys(data['linkage']).length !== 0) {
                for(let i in data['linkage']) {
                    this.data.childComponent[i]['data']['linkage']= this.data.data[i]["linkage"] = this.data.allLinkageData[i]= data['linkage'][i];
                }
                this.data.isAddLinkage = true;
                this.actions.changeOptions();
            }
        })
	},

	beforeDestory() {
		delete window.top.frontendParentFormValue[this.tableId];
		delete window.top.frontendRelation[this.tableId];
		Mediator.removeAll('attachment:upLoading');
		this.el.off();
	}
}

let BaseForm = Component.extend(config)
export default BaseForm



// WEBPACK FOOTER //
// app/components/form/base-form/base-form.js